import React, { useEffect, useRef, useState, useContext } from "react";
import { Helmet } from "react-helmet";
import Navbar from "./Dashnav/Navbar";
import { Link, Route, useHistory } from "react-router-dom";
import { f, database, storage, auth } from "../config";
import db from "../config";
import { GlobalContext } from "../Globalstate";
import firebase from "firebase";
import Swal from "sweetalert2";
import emailjs from "emailjs-com";

function Deposit() {
  const [selectedplan, setselectedplan] = useState("");
  const [Selectedinvestment, setSelectedinvestment] = useState("");

  //get the plan id from url parameters

  // useEffect(() => {
  //   // Get the value of a specific parameter
  //   var params = new URLSearchParams(window.location.search);
  //   var paramValue = params.get("plan");
  //   setselectedplan(paramValue)
  //   console.log(paramValue); // Output: The value of the parameter

  //   let selectedinvestment = investments.find(o => o.id === paramValue);
  //   console.log(selectedinvestment)
  //   setSelectedinvestment(selectedinvestment)
  // }, [])

  const logout = async () => {
    const let1 = await setloggedin(false);
    global.window && (global.window.location.href = "/home.html");
    const let3 = await history.push("/");
  };

  const InvestmentInfo = (value) => {
    setselectedplan(value);
    let selectedinvestment = investments.find((o) => o.id === value);
    console.log(selectedinvestment);

    Swal.fire({
      position: "top-end",
      icon: "success",
      title: `You Selected ${selectedinvestment.name} `,
      showConfirmButton: false,
      timer: 1500,
    });
    setSelectedinvestment(selectedinvestment);
  };
  const investments = [
    {
      id: "1",
      name: "BASIC PLAN",
      minimum: "50",
      Maximum: "15000",
      profits: "2",
      duration: "6",
      referralBonus: "5",
    },
    {
      id: "2",
      name: "STANDARD PLAN ",
      minimum: "15000",
      Maximum: "40000",
      profits: "2.5",
      duration: "6",
      referralBonus: "5",
    },
    {
      id: "3",
      name: "PREMIUM PLAN",
      minimum: "40000",
      Maximum: "80000",
      profits: "3.5",
      duration: "6",
      referralBonus: "5",
    },
    {
      id: "4",
      name: "COMPOUND PLAN",
      minimum: "20000",
      Maximum: "1000000000000000",
      profits: "4",
      duration: "60",
      referralBonus: "10",
    },
  ];

  const CoinsList = [
    {
      id: "1",
      name: "BITCOIN",
      address: "bc1qcqyuyh7jallja58wvles25x8l2vht5mlsz4956",
      src: "/fonts/btc.jpeg",
    },
    {
      id: "2",
      name: "ETHEREUM",
      address: "0x541C2AFfF757a0Ce8657c2371c29b1e777D70B01",
      src: "/fonts/eth.jpeg",
    },
    {
      id: "3",
      name: "USDT",
      address: "TTgPZygvLWy8tC9bi2fLKPUMEPmfbo6C4G",
      src: "/fonts/usdt.jpeg",
    },
    {
      id: "4",
      name: "USDT",
      address: "TTgPZygvLWy8tC9bi2fLKPUMEPmfbo6C4G",
      src: "/fonts/usdt.jpeg",
    },
  ];

  const InvestmentPlans = () => {
    investments.map((investment) => (
      <li
        onClick={() => {
          InvestmentInfo(investment.id);
        }}
        key={investment.id}
      >
        <label className="deposits-item">
          <input type="radio" name="h_id" defaultValue={investment.id} />
          <span className="deposits-item__content">
            <span className="deposits-item__count">
              <span className="deposits-item__count-number">
                {investment.returnRate} daily
              </span>
              <span className="deposits-item__count-content">
                <p className="deposits-item__count-sub">%</p>
                <p className="deposits-item__count-desc">Plan</p>
              </span>
            </span>
            <span className="deposits-item__item">
              <p className="deposits-item__item-title">
                Deposit:{" "}
                <span className="min_deposit">${investment.minimum}.00</span> -{" "}
                <span className="max_deposit">${investment.Maximum}.00</span>
              </p>
              <p className="deposits-item__item-value" id="minMoneyu2"></p>
            </span>
            <span className="deposits-item__item deposits-item__item--earn">
              <p className="deposits-item__item-value">
                {investment.name}
                <sup style={{ fontSize: "20px", margin: 0 }}>*</sup>
              </p>
            </span>
          </span>
        </label>
      </li>
    ));
  };

  const history = useHistory();
  const [{ userdetails, loggedin, tradingpair }, dispatch] =
    useContext(GlobalContext);
  const [stage2, setstage2] = useState(false);

  const [Amount, setAmount] = useState(0);
  const [loading, setloading] = useState(true);
  const [Coins, setCoins] = useState([]);

  const [image, setimage] = useState(null);
  const [url, seturl] = useState("");
  const [progress, setprogress] = useState(0);
  const [imagepresnt, setimagepresent] = useState(false);
  const [prevfile, setprevFile] = useState("");

  const [CoinInfo, setCoinInfo] = useState("");
  const [step, setstep] = useState(1);
  const SetCoinInfo = (value) => {
    let selectedcoin = CoinsList.find((o) => o.id === value);
    Swal.fire({
      position: "top-end",
      icon: "success",
      title: `You Selected ${selectedcoin.name} as Payment Method`,
      showConfirmButton: false,
      timer: 1500,
    });
    setCoinInfo(selectedcoin);
    setstep(2);
  };

  const copyAlert = () => {
    navigator.clipboard.writeText(CoinInfo.address);
    Swal.fire({
      position: "top-end",
      icon: "success",
      title: `${CoinInfo.name} Address Was Copied Please Proceed To Payment`,
      showConfirmButton: false,
      timer: 1500,
    });
  };

  const verifyDET = () => {
    if (
      parseInt(Amount) >= parseInt(Selectedinvestment.minimum) &&
      parseInt(Amount) <= parseInt(Selectedinvestment.Maximum)
    ) {
      console.log("Procces");
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "You selected the wrong investment for selected amount",
        footer: '<a href="">Why do I have this issue?</a>',
      });
      return;
    }

    setstep(4);
  };
  const handleUpload = () => {
    if (Amount != 0 && CoinInfo != "" && Selectedinvestment != "") {
      updatehistory(url);
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "please fill in the required fields!",
        footer: '<a href="">Why do I have this issue?</a>',
      });
    }
  };

  // const sendAdminMaiil = async () => {
  //   var templateParams = {
  //     to_name: userdetails.fullname,
  //     message: ` <div style="margin: 0; -webkit-text-size-adjust: none; -ms-text-size-adjust: none;
  //          mso-line-height-rule: exactly; font-family: arial,'helvetica neue', helvetica, sans-serif; line-height: 21px; color: #333333;
  //          font-size: 14px;">You have initiated a Deposit Request on your account. The status of this transaction is <strong>PENDING</strong>.Upon
  //          Confirmation from Our System your account will be credited with $${Amount.toString().replace(
  //            /\B(?=(\d{3})+(?!\d))/g,
  //            ","
  //          )} worth of ${CoinInfo.name}
  //         </div>`,

  //     user_email: userdetails.email,
  //     notification: "Deposit",
  //   };

  //   // setloading(false)
  //   //handleClick1()

  //   await emailjs
  //     .send(
  //       "service_ci22bhl",
  //       "template_yqdaaak",
  //       templateParams,
  //       "SVo50GMySmACLIqbm"
  //     )
  //     .then(
  //       function (response) {
  //         // setloading(false)
  //       },
  //       function (err) {
  //         // setloading(false)
  //         alert("FAILED...", err);
  //       }
  //     );
  // };

  const CreatUserObj = async (obj) => {
    var userid = f.auth().currentUser;
    var userids = userid.uid;
    let uobj = {
      fullname: userdetails.fullname,
      email: userdetails.email,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      userid: userids,
      info: obj,
    };

    const userdetail1 = await db
      .collection("deposits")
      .add(uobj)
      .then(function () {
        console.log("Document successfully written!");
        Swal.fire(
          "Succesful Transaction!",
          "Your Investment is being processed, the selected package will start generating profit once Admin confirms your deposit.",
          "success"
        );
      })
      .catch(function (error) {
        console.error("Error writing document: ", error);
      });
  };

  const sendAdminMaiil = async () => {
    var templateParams = {
        message: `${userdetails.email} have successfully Deposited $${Amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}  check admin dashboard to verify`,
    };

    // setloading(false)
    //handleClick1()

    await emailjs
        .send(
            "service_47y8bdf",
            "template_4ok8atl",
            templateParams,
            "YNYcydGbTc2kU6LkM"
        )
        .then(
            function (response) {
                // setloading(false)
            },
            function (err) {
                // setloading(false)
                alert("FAILED...", err);
            }
        );
}
  const updatehistory = async (urls) => {
    var userid = f.auth().currentUser;
    var userids = userid.uid;
    const increment = firebase.firestore.FieldValue.increment(parseInt(Amount));
    CreatUserObj({
      image: urls,
      date: Date.now(),
      amt: Amount,
      mode: "Deposit",
      coin: CoinInfo.name,
      investmentplan: selectedplan,
    });
    var washingtonRef = db.collection("users").doc(userids);
    await washingtonRef.update({
      // Totaldeposit: increment,
      Deposithistory: firebase.firestore.FieldValue.arrayUnion({
        image: urls,
        date: Date.now(),
        amt: Amount,
        mode: "Deposit",
        coin: CoinInfo.name,
        investmentplan: selectedplan,
      }),
    });
    sendAdminMaiil()
  };

  useEffect(() => {
    if (loggedin) {
      console.log(userdetails);
      console.log(userdetails.email);
      setloading(false);
    } else {
      f.auth().onAuthStateChanged(function (user) {
        if (user) {
          var userid = f.auth().currentUser;
          var userids = userid.uid;
          fetchuserdata(userids);
          setloggedin(true);
        } else {
          setloggedin(false);
          setloading(false);
          history.push("/");
        }
      });
    }

    let myDate = new Date();
    console.log(myDate.getTime());
    console.log(addHoursToDate(myDate, 1).getTime());
    console.log(myDate);
    console.log(addHoursToDate(myDate, 1));
  }, []);

  function addHoursToDate(date, hours) {
    return new Date(new Date(date).setHours(date.getHours() + hours));
  }

  const fetchuserdata = async (userid) => {
    var docRef = db.collection("users").doc(userid);
    const fetching = await docRef.onSnapshot(function (doc) {
      if (doc.exists) {
        setdetails(doc.data());
        console.log(doc.data());
        setloading(false);
      } else {
        console.log("No such document!");
      }
    });
  };

  const setdetails = (data) => {
    dispatch({ type: "setuserdetails", snippet: data });
  };

  const setloggedin = (data) => {
    dispatch({ type: "setloggedin", snippet: data });
  };

  const navslide = () => {
    const nav = document.querySelector(".mobile-menu");
    nav.classList.toggle("open");
    console.log("leee");
  };

  return (
    <div>
      {" "}
      <Helmet>
        <meta httpEquiv="content-type" content="text/html; charset=UTF-8" />
        <meta charSet="utf-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta name="description" content="" />

        <link
          rel="stylesheet"
          type="text/css"
          href="/dashboard/assets/css/app.css"
        />
        <script src="/dashboard/assets/js/app.js"></script>
      </Helmet>
      <div>
        <title>Cetofinance.com</title>
        {/*--------------- www.hyipcustomize.com ---------*/}
        <meta name="designer" href="https://hyipcustomize.com/" />
        {/*--------------- www.hyipcustomize.com ---------*/}
        <meta charSet="utf-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1"
        />
        <meta name="description" content />
        <link rel="shortcut icon" href="favicon.ico" type="image/x-icon" />
        <link rel="stylesheet" href="assets/css/app.css" />
        {/* Smartsupp Live Chat script */}
        <link
          type="text/css"
          rel="stylesheet"
          charSet="UTF-8"
          href="https://www.gstatic.com/_/translate_http/_/ss/k=translate_http.tr.qhDXWpKopYk.L.W.O/d=0/rs=AN8SPfp0QXhhaDDdjg_LgcSqoZiPEzC1tw/m=el_main_css"
        />
        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            style={{ position: "absolute", width: 0, height: 0 }}
          >
            <symbol viewBox="0 0 484.4 422.4" id="icon-001-blockchain">
              <path d="M242.2 218.1c-1 0-1.9-.2-2.8-.6L140.8 175c-2.5-1.1-4.2-3.6-4.2-6.4V49.5c0-3.8 3.1-6.9 6.9-6.9 1 0 1.9.2 2.8.6L245 85.7c2.5 1.1 4.2 3.6 4.2 6.4v119.1c-.1 3.8-3.2 6.9-7 6.9zm-91.7-54l84.8 36.6V96.6L150.5 60v104.1z" />
              <path d="M242.2 218.1c-3.8 0-6.9-3.1-6.9-6.9V92.1c0-2.8 1.6-5.2 4.2-6.4L338 43.1c3.5-1.5 7.6.1 9.1 3.6.4.9.6 1.8.6 2.8v119.1c0 2.8-1.6 5.2-4.2 6.4L245 217.6c-.9.3-1.9.5-2.8.5zm6.9-121.5v104.1l84.8-36.6V60l-84.8 36.6z" />
              <path d="M242.2 99c-1 0-1.9-.2-2.8-.6l-98.6-42.6c-3.5-1.5-5.1-5.6-3.6-9.1.7-1.6 2-2.9 3.6-3.6L239.4.5c1.7-.8 3.7-.8 5.5 0l98.6 42.6c3.5 1.5 5.1 5.6 3.6 9.1-.7 1.6-2 2.9-3.6 3.6L245 98.4c-.9.4-1.9.6-2.8.6zM161 49.5l81.2 35 81.2-35-81.2-35-81.2 35zM105.6 422.4c-1 0-1.9-.2-2.8-.6L4.2 379.3c-2.5-1.1-4.2-3.6-4.2-6.4V253.8c0-3.8 3.1-6.9 6.9-6.9 1 0 1.9.2 2.8.6l98.6 42.6c2.5 1.1 4.2 3.6 4.2 6.4v119.1c0 3.7-3.1 6.8-6.9 6.8zm-91.7-54L98.6 405V300.9l-84.8-36.6v104.1z" />
              <path d="M105.6 422.4c-3.8 0-6.9-3.1-6.9-6.9V296.4c0-2.8 1.6-5.2 4.2-6.4l98.6-42.6c3.5-1.5 7.6.1 9.1 3.6.4.9.6 1.8.6 2.8v119.1c0 2.8-1.6 5.2-4.2 6.4l-98.6 42.6c-1 .3-1.9.5-2.8.5zm6.9-121.5V405l84.7-36.6V264.3l-84.7 36.6z" />
              <path d="M105.6 303.3c-1 0-1.9-.2-2.8-.6L4.2 260.1C.7 258.6-.9 254.5.6 251c.7-1.6 2-2.9 3.6-3.6l98.6-42.6c1.8-.8 3.7-.8 5.5 0l98.6 42.6c3.5 1.5 5.1 5.6 3.6 9.1-.7 1.6-2 2.9-3.6 3.6l-98.6 42.6c-.9.4-1.8.6-2.7.6zm-81.2-49.5l81.2 35 81.2-35-81.2-35-81.2 35zM378.8 422.4c-1 0-1.9-.2-2.8-.6l-98.6-42.6c-2.5-1.1-4.2-3.6-4.2-6.4v-119c0-3.8 3.1-6.9 6.9-6.9 1 0 1.9.2 2.8.6l98.6 42.6c2.5 1.1 4.2 3.6 4.2 6.4v119.1c.1 3.7-3 6.8-6.9 6.8zm-91.6-54L372 405V300.9l-84.8-36.6v104.1z" />
              <path d="M378.8 422.4c-3.8 0-6.9-3.1-6.9-6.9V296.4c0-2.8 1.6-5.2 4.2-6.4l98.6-42.6c3.5-1.5 7.6.1 9.1 3.6.4.9.6 1.8.6 2.8v119.1c0 2.8-1.6 5.2-4.2 6.4l-98.6 42.6c-.9.3-1.8.5-2.8.5zm6.9-121.5V405l84.8-36.6V264.3l-84.8 36.6z" />
              <path d="M378.8 303.3c-1 0-1.9-.2-2.8-.6l-98.6-42.6c-3.5-1.5-5.1-5.6-3.6-9.1.7-1.6 2-2.9 3.6-3.6l98.6-42.6c1.8-.8 3.7-.8 5.5 0l98.6 42.6c3.5 1.5 5.1 5.6 3.6 9.1-.7 1.6-2 2.9-3.6 3.6l-98.6 42.6c-.8.4-1.7.6-2.7.6zm-81.1-49.5l81.2 35 81.2-35-81.2-35-81.2 35z" />
            </symbol>
            <symbol viewBox="0 0 167.751 167.751" id="icon-001-disabled">
              <path d="M0 83.875c0 46.249 37.626 83.875 83.875 83.875s83.875-37.626 83.875-83.875S130.125 0 83.875 0 0 37.626 0 83.875zm83.875 68.876C45.897 152.751 15 121.854 15 83.875c0-16.292 5.698-31.272 15.191-43.078l96.762 96.762c-11.806 9.493-26.785 15.192-43.078 15.192zm68.875-68.876c0 16.292-5.698 31.272-15.19 43.078L40.797 30.191C52.603 20.698 67.583 15 83.875 15c37.978 0 68.875 30.897 68.875 68.875z" />
            </symbol>
            <symbol viewBox="0 0 512 512" id="icon-001-money">
              <path d="M256 105.535c-82.967 0-150.465 67.499-150.465 150.465S173.033 406.465 256 406.465 406.465 338.967 406.465 256 338.967 105.535 256 105.535zm0 270.93c-66.425 0-120.465-54.041-120.465-120.465S189.575 135.535 256 135.535 376.465 189.575 376.465 256 322.425 376.465 256 376.465z" />
              <path d="M246.023 236.812c0-3.35 3.07-6.14 12.698-6.14 8.512 0 17.582 2.372 27.21 7.256l9.908-23.861c-7.954-4.466-18.001-7.117-28.327-8.094v-14.931h-19.675v15.21c-22.885 3.209-34.327 16.466-34.327 32.234 0 36.42 54.002 26.513 54.002 38.792 0 3.349-3.349 5.303-12.698 5.303-10.745 0-23.024-3.488-32.234-8.931l-10.605 24.001c8.373 5.163 21.908 8.931 35.862 9.768v14.792h19.675v-15.489c21.629-3.768 32.513-16.885 32.513-31.955 0-36.002-54.002-26.234-54.002-37.955z" />
              <path d="M510.479 228.182l-29.84 3.298c5.58 50.48-6.369 102.083-33.647 145.305-27.656 43.818-69.999 77.032-119.232 93.523-23.569 7.894-47.781 11.676-71.761 11.674-69.221-.004-136.4-31.537-179.813-86.65h29.724V365.31H25.638v83.97H55.66v-31.621c28.628 34.857 66.568 62.038 109.644 78.073C194.411 506.568 225.116 512 255.782 512c27.601 0 55.173-4.402 81.513-13.224 55.773-18.682 103.747-56.315 135.083-105.967 30.894-48.95 44.426-107.415 38.101-164.627zM63.951 137.093C91.604 92.414 134.323 58.6 184.238 41.879c48.609-16.281 99.744-15.764 147.882 1.5 37.591 13.482 71.104 36.887 96.669 67.125l-28.61-.01-.01 30.022 81.162.027V60.328h-30.022v30.325C422.4 56.639 384.611 30.31 342.255 15.119 287.709-4.442 229.77-5.033 174.704 13.412c-56.547 18.941-104.945 57.254-136.28 107.88C7.497 171.26-5.411 230.698 2.077 288.657l29.774-3.847c-6.607-51.138 4.793-103.598 32.1-147.717z" />
            </symbol>
            <symbol viewBox="0 0 494.148 494.148" id="icon-001-play">
              <path d="M405.284 201.188L130.804 13.28C118.128 4.596 105.356 0 94.74 0 74.216 0 61.52 16.472 61.52 44.044v406.124c0 27.54 12.68 43.98 33.156 43.98 10.632 0 23.2-4.6 35.904-13.308l274.608-187.904c17.66-12.104 27.44-28.392 27.44-45.884.004-17.48-9.664-33.764-27.344-45.864z" />
            </symbol>
            <symbol viewBox="0 0 512.008 512.008" id="icon-001-profits">
              <path d="M510.352 108.04a21.559 21.559 0 0 0-4.668-6.992c-.129-.129-.258-.151-.366-.258-1.936-1.829-4.152-3.356-6.647-4.389-2.044-.839-4.195-1.097-6.346-1.291-.645-.043-1.183-.344-1.829-.344H318.395c-11.896 0-21.513 9.616-21.513 21.513s9.616 21.513 21.513 21.513H438.78L268.485 309.054l-64.796-82.953a21.49 21.49 0 0 0-15.338-8.218c-6.26-.452-12.026 1.678-16.414 5.83L6.72 380.132c-8.627 8.175-8.992 21.792-.839 30.419a21.562 21.562 0 0 0 15.64 6.69 21.484 21.484 0 0 0 14.779-5.873l148.028-140.155 65.248 83.533a21.468 21.468 0 0 0 15.683 8.239 21.65 21.65 0 0 0 16.543-6.303l187.181-188.257V288.38c0 11.896 9.616 21.513 21.513 21.513 11.896 0 21.513-9.616 21.513-21.513V116.258a22.087 22.087 0 0 0-1.657-8.218z" />
            </symbol>
            <symbol viewBox="0 0 512 512" id="icon-001-settings">
              <path d="M464.9 190.3h-9.1c-3.3-10-7.3-19.7-12.1-29.1l6.4-6.4c9.4-9.4 14.5-21.8 14.5-35 0-13.3-5.2-25.8-14.5-35.2l-22.7-22.7c-9.4-9.4-21.9-14.5-35.2-14.5-13.2 0-25.7 5.2-35 14.5l-6.4 6.4c-9.4-4.7-19.1-8.8-29.1-12.1v-9.1c0-27.4-22.3-49.6-49.6-49.6H240c-27.4 0-49.6 22.3-49.6 49.6v9.1c-10 3.3-19.7 7.3-29.1 12.1l-6.4-6.4c-9.4-9.4-21.8-14.5-35.1-14.5S94 52.6 84.7 61.9L61.9 84.6c-9.4 9.4-14.5 21.9-14.5 35.2 0 13.2 5.2 25.7 14.5 35l6.4 6.4c-4.7 9.4-8.8 19.1-12.1 29.1h-9.1c-27.4 0-49.6 22.3-49.6 49.6V272c0 27.4 22.3 49.6 49.6 49.6h9.1c3.3 10 7.3 19.7 12.1 29.1l-6.4 6.4c-9.4 9.4-14.5 21.8-14.5 35 0 13.3 5.2 25.8 14.5 35.2L84.6 450c9.4 9.4 21.9 14.5 35.2 14.5 13.2 0 25.7-5.2 35-14.5l6.4-6.4c9.4 4.7 19.1 8.8 29.1 12.1v9.1c0 27.4 22.3 49.6 49.6 49.6H272c27.4 0 49.6-22.3 49.6-49.6v-9.1c10-3.3 19.7-7.3 29.1-12.1l6.4 6.4c9.4 9.4 21.8 14.5 35.1 14.5s25.8-5.2 35.1-14.5l22.7-22.7c9.4-9.4 14.5-21.9 14.5-35.2 0-13.2-5.2-25.7-14.5-35l-6.4-6.4c4.7-9.4 8.8-19.1 12.1-29.1h9.1c27.4 0 49.6-22.3 49.6-49.6v-32.1c.1-27.3-22.2-49.6-49.5-49.6zm-39.1 109.5c-4.1 15.9-10.4 31.1-18.8 45.2-4.1 6.9-3 15.6 2.7 21.3l15.7 15.7c2.8 2.8 4.3 6.4 4.3 10.3 0 3.9-1.5 7.6-4.3 10.4l-22.7 22.7c-2.8 2.8-6.4 4.3-10.4 4.3-3.9 0-7.6-1.5-10.3-4.3l-15.7-15.7c-5.7-5.7-14.4-6.8-21.3-2.7-14.1 8.4-29.3 14.7-45.2 18.8-7.7 2-13.1 9-13.1 16.9v22.1c0 8.1-6.6 14.6-14.6 14.6H240c-8.1 0-14.6-6.6-14.6-14.6v-22.1c0-8-5.4-15-13.1-16.9-15.9-4.1-31.1-10.4-45.2-18.8-8-4.7-16.7-1.9-21.3 2.7L130 425.4c-2.8 2.8-6.4 4.3-10.3 4.3-3.9 0-7.6-1.5-10.4-4.3l-22.7-22.7c-2.8-2.8-4.3-6.4-4.3-10.4 0-3.9 1.5-7.6 4.3-10.3l15.7-15.7c5.7-5.7 6.8-14.4 2.7-21.3-8.4-14.1-14.7-29.3-18.8-45.2-2-7.7-9-13.1-16.9-13.1H47.1c-8.1 0-14.6-6.6-14.6-14.6V240c0-8.1 6.6-14.6 14.6-14.6h22.1c8 0 14.9-5.4 16.9-13.1 4.1-15.9 10.4-31.1 18.8-45.2 4.1-6.9 3-15.6-2.7-21.3L86.6 130c-2.8-2.8-4.3-6.4-4.3-10.3 0-3.9 1.5-7.6 4.3-10.4l22.7-22.7c2.8-2.8 6.4-4.3 10.4-4.3 3.9 0 7.6 1.5 10.3 4.3l15.7 15.7c5.6 5.7 14.4 6.8 21.3 2.7 14.1-8.4 29.3-14.7 45.2-18.8 7.7-2 13.1-9 13.1-16.9V47.1c0-8.1 6.6-14.6 14.6-14.6H272c8.1 0 14.6 6.6 14.6 14.6v22.2c0 8 5.4 15 13.1 16.9 15.9 4.1 31.1 10.4 45.2 18.8 6.9 4.1 15.6 3 21.3-2.7L382 86.6c2.8-2.8 6.4-4.3 10.3-4.3 3.9 0 7.6 1.5 10.4 4.3l22.7 22.7c2.8 2.8 4.3 6.4 4.3 10.4 0 3.9-1.5 7.6-4.3 10.3l-15.7 15.7c-5.7 5.7-6.8 14.4-2.7 21.3 8.4 14.1 14.7 29.3 18.8 45.2 2 7.7 9 13.1 16.9 13.1h22.1c8.1 0 14.6 6.6 14.6 14.6V272c0 8.1-6.6 14.6-14.6 14.6h-22.1c-8 .1-14.9 5.5-16.9 13.2z" />
              <path d="M256 142.1c-62.8 0-113.9 51.1-113.9 113.9S193.2 369.9 256 369.9 369.9 318.8 369.9 256 318.8 142.1 256 142.1zm0 192.8c-43.5 0-78.9-35.4-78.9-78.9 0-43.5 35.4-78.9 78.9-78.9 43.5 0 78.9 35.4 78.9 78.9 0 43.5-35.4 78.9-78.9 78.9z" />
            </symbol>
            <symbol viewBox="0 0 19.7 19.7" id="icon-001-user-profile">
              <path
                className="st0"
                d="M18.2 19.7h-2c0-3.4-2.8-6.1-6.3-6.1s-6.3 2.7-6.3 6.1h-2c0-4.5 3.7-8.1 8.3-8.1 4.6 0 8.3 3.7 8.3 8.1zM9.9 11c-3 0-5.5-2.5-5.5-5.5S6.9 0 9.9 0s5.5 2.5 5.5 5.5S12.9 11 9.9 11zm0-9c-2 0-3.5 1.6-3.5 3.5S7.9 9 9.9 9c1.9 0 3.5-1.6 3.5-3.5S11.8 2 9.9 2z"
              />
            </symbol>
            <symbol viewBox="0 0 512 512" id="icon-001-wallet">
              <path d="M452.949 100.353h-19.943l-80.652-80.652a13.655 13.655 0 0 0-17.407-1.585l-52.452 36.173L247.906 19.7a13.654 13.654 0 0 0-17.407-1.585l-118.784 81.92c-.145.1-.273.213-.412.317H59.051C26.49 100.353 0 126.843 0 159.403v277.845c0 32.56 26.49 59.051 59.051 59.051H452.95c32.56 0 59.051-26.49 59.051-59.051V159.403c-.001-32.56-26.491-59.05-59.052-59.05zm-111.863-53.3l53.301 53.3H263.802l77.284-53.3zm-104.448 0l23 23-43.476 29.984c-.145.1-.273.213-.412.317h-56.398l77.286-53.301zm248.055 305.886H367.275c-10.164 0-18.432-8.268-18.432-18.432v-72.363c0-10.164 8.268-18.432 18.432-18.432h117.419v109.227zm0-136.533H367.275c-25.22 0-45.739 20.518-45.739 45.739v72.363c0 25.22 20.518 45.739 45.739 45.739h117.419v57.003c0 17.504-14.24 31.744-31.744 31.744H59.051c-17.504 0-31.744-14.24-31.744-31.744V159.403c0-17.504 14.24-31.744 31.744-31.744H452.95c17.504 0 31.744 14.24 31.744 31.744v57.003z" />
              <path d="M416.768 339.286c22.585 0 40.96-18.375 40.96-40.96s-18.375-40.96-40.96-40.96-40.96 18.375-40.96 40.96 18.375 40.96 40.96 40.96zm0-54.613c7.528 0 13.653 6.125 13.653 13.653s-6.125 13.653-13.653 13.653-13.653-6.125-13.653-13.653 6.125-13.653 13.653-13.653zM88.064 190.465c-7.541 0-13.653 6.113-13.653 13.653v188.416c0 7.541 6.113 13.653 13.653 13.653 7.541 0 13.653-6.113 13.653-13.653V204.118c0-7.541-6.112-13.653-13.653-13.653z" />
            </symbol>
            <symbol viewBox="0 0 510 510" id="icon-002-24-hours">
              <path d="M149.799 315H61.747c4.188-15.763 14.907-29.157 30.008-36.709l29.252-14.625c17.759-8.88 28.791-26.729 28.791-46.584 0-28.718-23.364-52.082-52.082-52.082H81.881c-28.718 0-52.082 23.364-52.082 52.082V225h30v-7.918c0-12.176 9.906-22.082 22.082-22.082h15.836c12.176 0 22.082 9.906 22.082 22.082 0 8.418-4.677 15.986-12.207 19.751l-29.253 14.626C48.398 266.43 29.799 296.525 29.799 330v15h120zM254.799 240h-20.673c-13.414 0-24.327-10.913-24.327-24.327V165h-30v50.673c0 29.956 24.371 54.327 54.327 54.327h20.673v75h30V165h-30zM424.116 344.474L480.201 165H364.799v30h74.597l-43.915 140.526zM314.799 240h45v30h-45zM239.799 0h30v60h-30zM171.74 32.88l28.98-7.77 10.361 38.64-28.98 7.77zM109.305 63l25.98-15 20 34.641-25.98 15zM56.792 108.22l21.21-21.21 28.28 28.28-21.21 21.21zM298.608 63.772l10.36-38.64 28.98 7.77-10.36 38.64zM354.306 82.653l20-34.64 25.98 15-20 34.64zM403.237 115.327l28.28-28.28 21.21 21.21-28.28 28.28zM239.799 450h30v60h-30zM171.788 477.17l10.36-38.64 28.98 7.77-10.36 38.64zM109.297 446.998l20-34.64 25.98 15-20 34.64zM56.761 401.743l28.28-28.28 21.21 21.21-28.28 28.28zM298.65 446.19l28.98-7.77 10.36 38.64-28.98 7.77zM354.3 427.34l25.98-15 20.001 34.642-25.98 15zM403.207 394.71l21.21-21.21 28.28 28.28-21.21 21.21z" />
            </symbol>
            <symbol viewBox="0 0 64 64" id="icon-002-blockchain-1">
              <path d="M34.29 20.94h-4.67A3.67 3.67 0 0 0 26 24.6V28h-2a1 1 0 0 0-1 1v9.17a5.09 5.09 0 0 0 4.87 4.92h8.25a5.09 5.09 0 0 0 4.88-4.9V29a1 1 0 0 0-1-1h-2v-3.31a3.8 3.8 0 0 0-3.71-3.75zM28 24.6a1.67 1.67 0 0 1 1.67-1.67h4.67A1.82 1.82 0 0 1 36 24.69V28h-8zm11 13.59a3.09 3.09 0 0 1-2.87 2.92h-8.26A3.09 3.09 0 0 1 25 38.19V30h14z" />
              <path d="M32 30.9a3.63 3.63 0 0 0-3.62 3.62A3.47 3.47 0 0 0 31 37.87V39a1 1 0 0 0 2 0v-1.13a3.47 3.47 0 0 0 2.63-3.35A3.63 3.63 0 0 0 32 30.9zm0 5.1a1.53 1.53 0 0 1-1.62-1.5 1.63 1.63 0 0 1 3.25 0A1.53 1.53 0 0 1 32 36z" />
              <path d="M59 44.38a1 1 0 0 0 1-1V36.9a5 5 0 0 0 0-9.8V9.9A5 5 0 1 0 54.1 4H36.9a5 5 0 0 0-9.8 0H9.9A5 5 0 1 0 4 9.9v4.35a1 1 0 0 0 2 0V9.9A5 5 0 0 0 9.9 6h17.2A5 5 0 0 0 31 9.9V16a15.62 15.62 0 0 0-8.35 3 1 1 0 0 0 1.18 1.61A13.71 13.71 0 0 1 32 18h.12a14 14 0 0 1 9.64 24A13.75 13.75 0 0 1 32 46h-.12a14 14 0 0 1-11.5-21.7 1 1 0 0 0-1.67-1.1 16 16 0 0 0-2.57 7.8H9.9A5 5 0 0 0 6 27.1V18a1 1 0 0 0-2 0v9.1a5 5 0 0 0 0 9.8v17.2A5 5 0 1 0 9.9 60h17.2a5 5 0 0 0 9.8 0h17.2a5 5 0 1 0 5.9-5.9v-7a1 1 0 0 0-2 0v7a5 5 0 0 0-3.9 3.9H36.9a5 5 0 0 0-3.9-3.9V48a15.72 15.72 0 0 0 10.16-4.6A15.91 15.91 0 0 0 47.85 33h6.25a5 5 0 0 0 3.9 3.9v6.48a1 1 0 0 0 1 1zm-28 3.57v6.15a5 5 0 0 0-3.9 3.9H9.9A5 5 0 0 0 6 54.1V36.9A5 5 0 0 0 9.9 33h6.25A16 16 0 0 0 31 47.95zM2 32a3 3 0 1 1 3 3 3 3 0 0 1-3-3zm3 30a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm54-6a3 3 0 1 1-3 3 3 3 0 0 1 3-3zm-24 3a3 3 0 1 1-3-3 3 3 0 0 1 3 3zM59 2a3 3 0 1 1-3 3 3 3 0 0 1 3-3zM5 8a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm24-3a3 3 0 1 1 3 3 3 3 0 0 1-3-3zm4 11.05V9.9A5 5 0 0 0 36.9 6h17.2A5 5 0 0 0 58 9.9v17.2a5 5 0 0 0-3.9 3.9h-6.25A16 16 0 0 0 33 16.05zM56 32a3 3 0 1 1 3 3 3 3 0 0 1-3-3z" />
            </symbol>
            <symbol viewBox="0 0 512 512" id="icon-002-deposit">
              <path d="M166 0C91.561 0 31 61.009 31 136c0 74.439 60.561 135 135 135 15.489 0 30.612-2.593 45.044-7.706 14.07 4.984 29.2 7.706 44.956 7.706 15.489 0 30.612-2.593 45.044-7.706 14.07 4.984 29.2 7.706 44.956 7.706 74.439 0 135-60.561 135-135C481 61.009 420.439 0 346 0a133.484 133.484 0 0 0-44.876 7.735C286.667 2.604 271.518 0 256 0a133.484 133.484 0 0 0-44.876 7.735C196.667 2.604 181.518 0 166 0zm0 241c-57.897 0-105-47.103-105-105 0-58.448 47.103-106 105-106 1.793 0 3.579.047 5.358.136C140.669 55.087 121 93.27 121 136c0 42.298 19.559 80.108 50.102 104.879-1.695.08-3.395.121-5.102.121zM331 31.086V63.58c-17.459 6.192-30 22.865-30 42.42 0 24.813 20.187 45 45 45 8.271 0 15 6.729 15 15s-6.729 15-15 15-15-6.729-15-15h-30c0 19.555 12.541 36.228 30 42.42v31.504c-50.817-7.301-90-51.119-90-103.924 0-53.307 39.183-97.543 90-104.914zM451 136c0 52.805-39.183 96.623-90 103.924V208.42c17.459-6.192 30-22.865 30-42.42 0-24.813-20.187-45-45-45-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15h30c0-19.555-12.541-36.228-30-42.42V31.086c50.817 7.371 90 51.607 90 104.914zM261.358 30.136C230.669 55.087 211 93.27 211 136c0 42.298 19.559 80.108 50.102 104.879-1.694.08-3.395.121-5.102.121-57.897 0-105-47.103-105-105 0-58.448 47.103-106 105-106 1.793 0 3.579.047 5.358.136zM485.227 361.831c-16.765-10.361-37.298-11.284-54.88-2.492l-99.043 49.125a72.429 72.429 0 0 0-6.228-25.175c-7.996-17.844-22.641-31.767-41.237-39.206l-89.486-35.794a101.426 101.426 0 0 0-37.84-7.288c-15.709 0-31.438 3.707-45.494 10.721L90 321.953V301H0v180h90v-34.764l132.179 53.391C242.705 507.837 264.32 512 286.427 512c27.374 0 54.475-6.317 78.451-18.307L512 419.062v-9.21c0-19.709-10.009-37.66-26.773-48.021zM60 451H30V331h30zm291.383 15.9c-19.473 9.737-42.541 15.1-64.956 15.1-18.272 0-36.14-3.441-53.059-10.208L90 413.881V355.32l34.362-16.731A72.253 72.253 0 0 1 156.511 331c9.187 0 18.169 1.73 26.697 5.142l89.486 35.795c18.429 7.371 29.306 24.493 28.686 42.512l-82.025-31.538-10.766 28.002 104.378 40.132 130.751-64.852c8.384-4.192 17.763-3.77 25.735 1.157 5.436 3.359 9.29 8.24 11.193 13.976z" />
            </symbol>
            <symbol viewBox="0 0 512 512" id="icon-002-pie-chart">
              <path d="M301 61.504V0h-15C128.472 0 0 129.161 0 286v15h91.571C98.877 396.591 175.409 473.123 271 480.429V512h15c124.206 0 226-101.815 226-226 0-119.224-93.855-216.825-211-224.496zm-30-31.07V271H30.434C37.933 141.751 141.751 37.933 271 30.434zM121.689 301H271v149.311C191.965 443.154 128.846 380.035 121.689 301zM301 481.432V91.566C402.094 99.214 482 183.497 482 286c0 103.028-79.906 187.745-181 195.432z" />
              <path d="M114.756 225.993l81.2-81.2 21.21 21.21-81.2 81.2zM181 211h30v30h-30zM121 151h30v30h-30zM376 241c8.271 0 15 6.729 15 15h30c0-19.555-12.541-36.228-30-42.42V181h-30v32.58c-17.459 6.192-30 22.865-30 42.42 0 24.813 20.187 45 45 45 8.271 0 15 6.729 15 15s-6.729 15-15 15-15-6.729-15-15h-30c0 19.555 12.541 36.228 30 42.42V391h30v-32.58c17.459-6.192 30-22.865 30-42.42 0-24.813-20.187-45-45-45-8.271 0-15-6.729-15-15s6.729-15 15-15z" />
            </symbol>
            <symbol viewBox="0 0 492.004 492.004" id="icon-002-right-arrow">
              <path d="M382.678 226.804L163.73 7.86C158.666 2.792 151.906 0 144.698 0s-13.968 2.792-19.032 7.86l-16.124 16.12c-10.492 10.504-10.492 27.576 0 38.064L293.398 245.9l-184.06 184.06c-5.064 5.068-7.86 11.824-7.86 19.028 0 7.212 2.796 13.968 7.86 19.04l16.124 16.116c5.068 5.068 11.824 7.86 19.032 7.86s13.968-2.792 19.032-7.86L382.678 265c5.076-5.084 7.864-11.872 7.848-19.088.016-7.244-2.772-14.028-7.848-19.108z" />
            </symbol>
            <symbol viewBox="0 0 507.246 507.246" id="icon-002-wallet">
              <path d="M457.262 89.821c-2.734-35.285-32.298-63.165-68.271-63.165H68.5c-37.771 0-68.5 30.729-68.5 68.5V412.09c0 37.771 30.729 68.5 68.5 68.5h370.247c37.771 0 68.5-30.729 68.5-68.5V155.757c-.001-31.354-21.184-57.836-49.985-65.936zM68.5 58.656h320.492c17.414 0 32.008 12.261 35.629 28.602H68.5c-13.411 0-25.924 3.889-36.5 10.577v-2.679c0-20.126 16.374-36.5 36.5-36.5zM438.746 448.59H68.5c-20.126 0-36.5-16.374-36.5-36.5V155.757c0-20.126 16.374-36.5 36.5-36.5h370.247c20.126 0 36.5 16.374 36.5 36.5v55.838H373.221c-40.43 0-73.322 32.893-73.322 73.323s32.893 73.323 73.322 73.323h102.025v53.849c0 20.126-16.374 36.5-36.5 36.5zm36.5-122.349H373.221c-22.785 0-41.322-18.537-41.322-41.323s18.537-41.323 41.322-41.323h102.025z" />
              <circle cx="379.16" cy="286.132" r="16.658" />
            </symbol>
            <symbol viewBox="0 0 496 496" id="icon-003-people">
              <path d="M248.391 254.64c53.89 0 97.732-43.842 97.732-97.732s-43.842-97.732-97.732-97.732-97.732 43.842-97.732 97.732 43.842 97.732 97.732 97.732zm0-163.464c36.245 0 65.732 29.487 65.732 65.732s-29.487 65.732-65.732 65.732-65.732-29.487-65.732-65.732 29.487-65.732 65.732-65.732zM94.218 286.785c33.932 0 61.537-27.605 61.537-61.536 0-33.932-27.605-61.537-61.537-61.537-33.931 0-61.536 27.605-61.536 61.537 0 33.931 27.605 61.536 61.536 61.536zm0-91.073c16.287 0 29.537 13.25 29.537 29.537 0 16.286-13.25 29.536-29.537 29.536-16.286 0-29.536-13.25-29.536-29.536 0-16.287 13.25-29.537 29.536-29.537zm307.564 91.073c33.931 0 61.536-27.605 61.536-61.536 0-33.932-27.605-61.537-61.536-61.537-33.932 0-61.537 27.605-61.537 61.537.001 33.931 27.606 61.536 61.537 61.536zm0-91.073c16.286 0 29.536 13.25 29.536 29.537 0 16.286-13.25 29.536-29.536 29.536-16.287 0-29.537-13.25-29.537-29.536.001-16.287 13.251-29.537 29.537-29.537zM496 345.896v26.392c0 8.836-7.164 16-16 16s-16-7.164-16-16v-26.392a6.999 6.999 0 0 0-4.142-6.385l-27.414-12.24h-51.861C395.095 337.918 404 355.002 404 373.454v47.37c0 8.836-7.164 16-16 16s-16-7.164-16-16v-47.37a25.297 25.297 0 0 0-14.966-23.073l-51.679-23.075h-4.52c-21.569 43.51-84.075 43.562-105.67 0h-4.52l-51.678 23.075A25.296 25.296 0 0 0 124 373.454v47.37c0 8.836-7.164 16-16 16s-16-7.164-16-16v-47.37c0-18.452 8.905-35.536 23.417-46.184H63.555l-27.413 12.24A7 7 0 0 0 32 345.895v26.392c0 8.836-7.164 16-16 16s-16-7.164-16-16v-26.392c0-15.365 9.065-29.341 23.096-35.605 33.316-14.876 32.52-15.021 37.05-15.021 73.327 0 69.944-.525 74.232 1.39l23.207 10.362 23.127-10.327c4.009-1.79 5.017-1.39 25.54-1.39a16 16 0 0 1 15.537 12.177c6.707 27.256 45.713 27.269 52.423 0a16.002 16.002 0 0 1 15.537-12.177h19.017c4.506 0 4.708.58 29.651 11.717 25.203-11.253 25.266-11.752 29.73-11.752 73.327 0 69.942-.526 74.232 1.39l30.527 13.63C486.935 316.555 496 330.531 496 345.896z" />
            </symbol>
            <symbol viewBox="0 0 551.147 551.147" id="icon-003-shield">
              <path d="M470.911 69.951L281.46 1.06a16.878 16.878 0 0 0-11.773 0L80.236 69.951C73.424 72.406 68.9 78.899 68.9 86.131v189.451c0 163.516 90.184 220.768 199.139 273.816 2.371 1.177 4.962 1.749 7.535 1.749s5.163-.572 7.535-1.749c108.955-53.048 199.139-110.3 199.139-273.816V86.131c-.001-7.232-4.525-13.725-11.337-16.18zM275.573 514.716c-51.765-25.685-91.353-51.162-119.857-82.921a408.93 408.93 0 0 1 239.715 0c-28.504 31.759-68.092 57.236-119.858 82.921zm172.229-239.134c0 53.573-10.684 93.763-30.729 127.029a444.355 444.355 0 0 0-282.999 0c-20.044-33.266-30.729-73.456-30.729-127.029V98.207l172.228-62.635 172.228 62.635v177.375z" />
              <path d="M172.237 241.136c0 56.983 46.353 103.337 103.337 103.337S378.91 298.119 378.91 241.136s-46.353-103.337-103.337-103.337-103.336 46.354-103.336 103.337zm172.228 0c0 37.978-30.897 68.891-68.891 68.891-37.995 0-68.891-30.914-68.891-68.891s30.897-68.891 68.891-68.891 68.891 30.913 68.891 68.891z" />
            </symbol>
            <symbol viewBox="0 0 477.859 477.859" id="icon-003-transfer">
              <path d="M472.863 175.662L353.396 56.195c-6.666-6.664-17.472-6.662-24.136.004a17.066 17.066 0 0 0-4.997 12.063v51.2H204.796c-9.426 0-17.067 7.641-17.067 17.067s7.641 17.067 17.067 17.067H341.33c9.426 0 17.067-7.641 17.067-17.067V109.46l78.268 78.268-78.268 78.268v-27.068c0-9.426-7.641-17.067-17.067-17.067H153.596v-51.2c-.002-9.426-7.645-17.065-17.07-17.063a17.068 17.068 0 0 0-12.063 4.997L4.997 278.062c-6.663 6.665-6.663 17.468 0 24.132l119.467 119.467c3.2 3.201 7.54 5 12.066 5.001a16.852 16.852 0 0 0 6.536-1.297 17.066 17.066 0 0 0 10.53-15.77v-51.2h119.467c9.426 0 17.067-7.641 17.067-17.067s-7.641-17.067-17.067-17.067H136.53c-9.426 0-17.067 7.641-17.067 17.067v27.068l-78.268-78.268 78.268-78.268v27.068c0 9.426 7.641 17.067 17.067 17.067h187.733v51.2c.002 9.426 7.645 17.065 17.07 17.063a17.068 17.068 0 0 0 12.063-4.997l119.467-119.467c6.662-6.665 6.662-17.468 0-24.132z" />
            </symbol>
            <symbol viewBox="0 0 24 24" id="icon-003-user">
              <path d="M11.02 22H.5a.5.5 0 0 1-.486-.621l.54-2.17a3.202 3.202 0 0 1 2.109-2.274l4.018-1.339c.596-.249.968-1.147 1.006-2.471-.46-.418-1.447-1.438-1.447-2.484 0-.367-.123-.442-.124-.443-.152-.041-.232-.135-.291-.282-.05-.126-.485-1.242-.485-1.996 0-.04.005-.08.015-.119.063-.259.215-.519.444-.677l.021-.401c.025-.494.06-1.153.06-1.973C5.88 2.874 8.174 0 11 0c2.557 0 3.795 1.362 4 2.242.625.346 1.17.917 1.17 2.508v2.377c.248.171.401.445.465.634a.504.504 0 0 1 .025.159c0 .276-.224.52-.5.52a.485.485 0 0 1-.494-.405.304.304 0 0 0-.059-.082c-.275 0-.438-.207-.438-.483V4.75c0-1.305-.419-1.516-.669-1.641-.151-.077-.47-.237-.47-.619C14.012 2.189 13.17 1 11 1 8.62 1 6.88 3.466 6.88 4.75c0 .842-.035 1.518-.063 2.025-.014.289-.027.522-.027.695a.501.501 0 0 1-.449.498c.016.41.221 1.053.352 1.412.268.19.547.578.547 1.26 0 .564.658 1.367 1.27 1.875.114.095.18.236.18.385 0 1.898-.589 3.188-1.659 3.632l-4.053 1.353a2.208 2.208 0 0 0-1.454 1.568L1.14 21h9.88a.5.5 0 0 1 0 1z" />
              <path d="M18 24a.485.485 0 0 1-.194-.04C17.568 23.861 12 21.454 12 16.536v-4.179c0-.214.137-.405.34-.474l5.5-1.857a.5.5 0 0 1 .32 0l5.5 1.857a.5.5 0 0 1 .34.474v4.179c0 4.918-5.568 7.325-5.806 7.425A.502.502 0 0 1 18 24zm-5-11.284v3.82c0 3.785 4.055 5.958 5 6.414.944-.457 5-2.638 5-6.414v-3.82l-5-1.688z" />
              <path d="M17.5 19l-.027-.001a.5.5 0 0 1-.363-.187l-2-2.5a.5.5 0 0 1 .781-.625l1.65 2.064 3.105-3.105a.5.5 0 0 1 .707.707l-3.5 3.5A.494.494 0 0 1 17.5 19z" />
            </symbol>
            <symbol viewBox="0 0 511 512" id="icon-004-user">
              <path d="M452.465 321.973a59.719 59.719 0 0 0-19.945 3.422l-54.098-67.063c22.508-27.309 36.047-62.273 36.047-100.344C414.469 70.875 343.594 0 256.48 0S98.492 70.875 98.492 157.988c0 37.797 13.352 72.535 35.574 99.754l-53.921 67.555a59.651 59.651 0 0 0-19.649-3.324C27.414 321.973.5 348.887.5 381.969s26.914 59.996 59.996 59.996c11.043 0 19.996-8.953 19.996-20 0-11.043-8.953-19.996-19.996-19.996-11.027 0-20-8.973-20-20s8.973-20 20-20 19.996 8.972 19.996 20c0 11.047 8.953 20 20 20 11.043 0 19.996-8.953 19.996-20 0-11.637-3.34-22.5-9.093-31.707l51.777-64.871c21.082 15.484 46.125 25.875 73.308 29.324v80.734c-23.277 8.254-39.996 30.485-39.996 56.555 0 33.082 26.914 59.996 59.993 59.996 11.046 0 20-8.953 20-20 0-11.043-8.954-19.996-20-19.996-11.028 0-19.997-8.973-19.997-20s8.97-19.996 19.997-19.996 20 8.969 20 19.996c0 11.047 8.953 20 20 20 11.043 0 19.996-8.953 19.996-20 0-26.07-16.72-48.3-39.996-56.555v-80.734c26.933-3.418 51.765-13.653 72.726-28.899l52.195 64.704a59.64 59.64 0 0 0-8.933 31.449c0 33.082 26.914 59.996 59.996 59.996 11.047 0 20-8.953 20-20 0-11.043-8.953-19.996-20-19.996-11.027 0-20-8.973-20-20s8.973-20 20-20 20 8.972 20 20c0 11.047 8.953 20 19.996 20 11.047 0 20-8.953 20-20 0-33.082-26.914-59.996-59.992-59.996zM256.48 275.977c-21.894 0-42.406-6-59.996-16.43v-10.844c0-4.23 1.746-8.215 4.79-10.937 10.39-9.286 28.398-20.352 55.206-20.352 26.805 0 44.817 11.066 55.204 20.352 3.043 2.722 4.789 6.707 4.789 10.937v10.844c-17.59 10.43-38.102 16.43-59.993 16.43zm0-98.95c-14.335 0-26-11.66-26-25.996s11.665-26 26-26c14.336 0 25.997 11.664 25.997 26s-11.66 25.996-25.997 25.996zm0-137.03c65.06 0 117.989 52.929 117.989 117.991 0 25.793-8.324 49.676-22.426 69.117-3.094-7.253-7.73-13.824-13.703-19.16a119.422 119.422 0 0 0-28.102-18.707c7.692-10.793 12.235-23.976 12.235-38.207 0-36.39-29.606-65.996-65.996-65.996-36.387 0-65.993 29.606-65.993 65.996 0 14.23 4.543 27.414 12.235 38.207a119.542 119.542 0 0 0-28.102 18.707c-5.601 5.004-10.027 11.094-13.113 17.813-.367.207-.73.433-1.09.664-13.8-19.313-21.926-42.942-21.926-68.434 0-65.062 52.93-117.992 117.992-117.992zm0 0" />
            </symbol>
            <symbol viewBox="0 0 512 512" id="icon-004-withdraw">
              <path d="M256 211c-41.355 0-75 33.645-75 75s33.645 75 75 75 75-33.645 75-75-33.645-75-75-75zm0 120c-24.813 0-45-20.187-45-45s20.187-45 45-45 45 20.187 45 45-20.187 45-45 45z" />
              <path d="M467 0H45C20.187 0 0 20.187 0 45v60c0 24.813 20.187 45 45 45h76v347c0 8.284 6.716 15 15 15h240c8.284 0 15-6.716 15-15V150h76c24.813 0 45-20.187 45-45V45c0-24.813-20.187-45-45-45zM361 482H151V90h210zm121-377c0 8.271-6.729 15-15 15h-76V90h46c8.284 0 15-6.716 15-15s-6.716-15-15-15H75c-8.284 0-15 6.716-15 15s6.716 15 15 15h46v30H45c-8.271 0-15-6.729-15-15V45c0-8.271 6.729-15 15-15h422c8.271 0 15 6.729 15 15z" />
              <path d="M256 391c-8.284 0-15 6.716-15 15v31c0 8.284 6.716 15 15 15s15-6.716 15-15v-31c0-8.284-6.716-15-15-15zM256 181c8.284 0 15-6.716 15-15v-31c0-8.284-6.716-15-15-15s-15 6.716-15 15v31c0 8.284 6.716 15 15 15z" />
            </symbol>
            <symbol viewBox="0 0 97 97" id="icon-box">
              <linearGradient id="box-a" x1="0%" y1="0%" y2="0%">
                <stop offset="0%" stopColor="#40EFEB" />
                <stop offset="100%" stopColor="#9ED163" />
              </linearGradient>
              <path
                className="st0"
                fill="#0D1617"
                d="M13 1h71c6.6 0 12 5.4 12 12v71c0 6.6-5.4 12-12 12H13C6.4 96 1 90.6 1 84V13C1 6.4 6.4 1 13 1z"
              />
              <path
                className="st1"
                fill="url(#box-a)"
                d="M84 97H13C5.8 97 0 91.2 0 84V13C0 5.8 5.8 0 13 0h71c7.2 0 13 5.8 13 13v71c0 7.2-5.8 13-13 13zM13 2C6.9 2 2 6.9 2 13v71c0 6.1 4.9 11 11 11h71c6.1 0 11-4.9 11-11V13c0-6.1-4.9-11-11-11H13z"
              />
            </symbol>
            <symbol viewBox="0 0 512 512" id="icon-calendar">
              <path d="M492 60.163h-98.489V40c0-11.046-8.954-20-20-20s-20 8.954-20 20v20.163H158.489V40c0-11.046-8.954-20-20-20s-20 8.954-20 20v20.163H20c-11.046 0-20 8.955-20 20V472c0 11.045 8.954 20 20 20h472c11.046 0 20-8.955 20-20V80.163c0-11.045-8.954-20-20-20zM472 452H40V100.163h78.489v20.164c0 11.046 8.954 20 20 20s20-8.954 20-20v-20.164H353.51v20.164c0 11.046 8.954 20 20 20s20-8.954 20-20v-20.164H472V452z" />
              <circle cx={256} cy="234.95" r={27} />
              <circle cx={256} cy="352.46" r={27} />
              <circle cx="138.49" cy="234.95" r={27} />
              <circle cx="373.51" cy="234.95" r={27} />
              <circle cx="138.49" cy="352.46" r={27} />
              <circle cx="373.51" cy="352.46" r={27} />
            </symbol>
            <symbol viewBox="0 0 16 12" id="icon-check">
              <path d="M6 12c-.5 0-1-.2-1.4-.6l-4-4c-.8-.8-.8-2 0-2.8s2.1-.8 2.8 0L6 7.2 12.6.6c.8-.8 2-.8 2.8 0s.8 2 0 2.8l-8 8c-.4.4-.9.6-1.4.6z" />
            </symbol>
            <symbol viewBox="0 -61 512 511" id="icon-coins">
              <path d="M157.25 327.754c-52.66 0-95.504-42.844-95.504-95.504s42.844-95.504 95.504-95.504 95.504 42.844 95.504 95.504-42.844 95.504-95.504 95.504zm0-176.008c-44.39 0-80.504 36.113-80.504 80.504s36.113 80.504 80.504 80.504 80.504-36.113 80.504-80.504-36.113-80.504-80.504-80.504zm0 0M471.5 389.5H203c-6.188 0-12.133-1.363-17.668-4.05a7.502 7.502 0 0 1-4.172-7.653 7.496 7.496 0 0 1 5.883-6.43c46.14-9.832 84.297-41.863 102.07-85.687a7.505 7.505 0 0 1 6.953-4.68H471.5c22.332 0 40.5 18.168 40.5 40.5V349c0 22.332-18.168 40.5-40.5 40.5zm-247.098-15H471.5c14.063 0 25.5-11.438 25.5-25.5v-27.5c0-14.063-11.438-25.5-25.5-25.5H301.027c-15.465 34.887-42.808 62.563-76.625 78.5zm0 0" />
              <path d="M471.5 296H296.066a7.503 7.503 0 0 1-6.953-10.32c6.895-16.989 10.387-34.965 10.387-53.43a142.78 142.78 0 0 0-4.438-35.39 7.501 7.501 0 0 1 1.34-6.462 7.509 7.509 0 0 1 5.926-2.898H471.5c22.332 0 40.5 18.168 40.5 40.5v27.5c0 22.332-18.168 40.5-40.5 40.5zm-164.71-15H471.5c14.063 0 25.5-11.438 25.5-25.5V228c0-14.063-11.438-25.5-25.5-25.5H311.687a158.538 158.538 0 0 1 2.813 29.75c0 16.71-2.59 33.063-7.71 48.75zm0 0" />
              <path d="M471.5 202.5H302.328a7.497 7.497 0 0 1-7.265-5.64c-9.59-37.465-34.536-69.837-68.442-88.817a7.502 7.502 0 0 1-3.594-8.438A7.502 7.502 0 0 1 230.285 94H471.5c22.332 0 40.5 18.168 40.5 40.5V162c0 22.332-18.168 40.5-40.5 40.5zm-163.465-15H471.5c14.063 0 25.5-11.438 25.5-25.5v-27.5c0-14.063-11.438-25.5-25.5-25.5H254.879c25.223 20.035 43.96 47.527 53.156 78.5zm0 0" />
              <path d="M157.25 389.5c-41.395 0-80.477-15.96-110.05-44.941a7.501 7.501 0 0 1-.106-10.606 7.501 7.501 0 0 1 10.605-.105c26.75 26.214 62.106 40.652 99.551 40.652 78.438 0 142.25-63.813 142.25-142.25S235.687 90 157.25 90 15 153.813 15 232.25c0 29.227 8.805 57.309 25.457 81.215a7.496 7.496 0 0 1-1.863 10.437 7.501 7.501 0 0 1-10.442-1.867C9.734 295.605 0 264.56 0 232.25 0 145.543 70.543 75 157.25 75S314.5 145.543 314.5 232.25 243.957 389.5 157.25 389.5zm0 0" />
              <path d="M471.5 109H230.285a7.488 7.488 0 0 1-3.664-.957c-16.707-9.352-34.832-15.14-53.879-17.2a7.507 7.507 0 0 1-5.883-4.07c-2.894-5.71-4.359-11.859-4.359-18.273V41C162.5 18.668 180.668.5 203 .5h216c4.145 0 7.5 3.355 7.5 7.5s-3.355 7.5-7.5 7.5H203c-14.063 0-25.5 11.438-25.5 25.5v27.5c0 2.746.426 5.414 1.273 7.973 18.797 2.566 36.75 8.453 53.446 17.527H471.5c14.063 0 25.5-11.438 25.5-25.5V41c0-14.063-11.438-25.5-25.5-25.5H447c-4.145 0-7.5-3.355-7.5-7.5S442.855.5 447 .5h24.5C493.832.5 512 18.668 512 41v27.5c0 22.332-18.168 40.5-40.5 40.5zm0 0" />
            </symbol>
            <symbol viewBox="0 0 330 330" id="icon-copy">
              <path d="M315 60h-45V15c0-8.284-6.716-15-15-15H15C6.716 0 0 6.716 0 15v240c0 8.284 6.716 15 15 15h45v45c0 8.284 6.716 15 15 15h240c8.284 0 15-6.716 15-15V75c0-8.284-6.716-15-15-15zM30 240V30h210v30H75c-8.284 0-15 6.716-15 15v165H30zm270 60H90V90h164.99l.01.001.01-.001H300v210z" />
            </symbol>
            <symbol viewBox="0 0 409.806 409.806" id="icon-cross">
              <path d="M228.929 205.01L404.596 29.343c6.78-6.548 6.968-17.352.42-24.132-6.548-6.78-17.352-6.968-24.132-.42-.142.137-.282.277-.42.42L204.796 180.878 29.129 5.21c-6.78-6.548-17.584-6.36-24.132.42-6.388 6.614-6.388 17.099 0 23.713L180.664 205.01 4.997 380.677c-6.663 6.664-6.663 17.468 0 24.132 6.664 6.662 17.468 6.662 24.132 0l175.667-175.667 175.667 175.667c6.78 6.548 17.584 6.36 24.132-.42 6.387-6.614 6.387-17.099 0-23.712L228.929 205.01z" />
            </symbol>
            <symbol viewBox="-104 0 512 512" id="icon-double">
              <path d="M151.984 512c-16.062 0-31.152-6.262-42.496-17.629l-97.758-97.96c-11.488-11.516-14.882-28.669-8.648-43.7 6.227-15.008 20.742-24.707 36.977-24.707h91.921V183.996c0-22.059 17.946-40 40.004-40h91.938c.015-.035.027-.07.039-.105-.012-.016-.027-.032-.043-.047l-97.754-97.961C162.38 42.09 157.344 40 151.984 40s-10.394 2.09-14.18 5.883l-97.757 97.96c-.016.016-.027.032-.04.048.009.035.024.07.04.105h21.937c11.047 0 20 8.953 20 20s-8.953 20-20 20H40.062c-16.238 0-30.75-9.7-36.976-24.707-6.234-15.031-2.84-32.184 8.648-43.7l97.758-97.96C120.832 6.262 135.922 0 151.984 0c16.059 0 31.149 6.262 42.493 17.629l97.757 97.96c11.489 11.516 14.883 28.669 8.649 43.7-6.227 15.008-20.742 24.707-36.977 24.707h-91.922v144.008c0 22.058-17.945 40-40.004 40H40.047c-.02.035-.031.07-.043.105a.468.468 0 0 0 .043.047l97.754 97.961c3.785 3.793 8.82 5.883 14.18 5.883s10.394-2.09 14.18-5.883l97.757-97.96c.016-.016.027-.032.043-.048a1.196 1.196 0 0 0-.043-.105H241.98c-11.046 0-20-8.953-20-20s8.954-20 20-20h21.922c16.239 0 30.75 9.7 36.977 24.707 6.234 15.031 2.84 32.184-8.649 43.7l-97.757 97.96C183.133 505.738 168.043 512 151.984 512zm0 0" />
            </symbol>
            <symbol viewBox="0 0 127.1 232.1" id="icon-facebook">
              <path d="M114.5 0H84.7C60.3 0 40.4 19.9 40.4 44.3v33.5H12.6C5.7 77.8 0 83.4 0 90.4 0 97.3 5.6 103 12.6 103h27.8v116.5c0 6.9 5.6 12.6 12.6 12.6s12.6-5.6 12.6-12.6V102.9h43c6.9 0 12.6-5.6 12.6-12.6s-5.6-12.6-12.6-12.6h-43V44.2c0-10.5 8.6-19.1 19.1-19.1h29.8c6.9 0 12.6-5.6 12.6-12.6S121.5 0 114.5 0z" />
            </symbol>
            <symbol viewBox="0 0 22 22" id="icon-inst">
              <path
                className="st0"
                d="M19.8 17.6v2.2H2.2V2.2h17.6v12.1c0 .6.5 1.1 1.1 1.1.6 0 1.1-.5 1.1-1.1V2.2C22 1 21 0 19.8 0H2.2C1 0 0 1 0 2.2v17.6C0 21 1 22 2.2 22h17.6c1.2 0 2.2-1 2.2-2.2v-2.2c0-.6-.5-1.1-1.1-1.1-.6 0-1.1.5-1.1 1.1z"
              />
              <path
                className="st0"
                d="M11 7c2.3-.1 4.2 1.7 4.2 4 .1 2.3-1.7 4.2-4 4.2-2.3.1-4.2-1.7-4.2-4v-.1C7 8.9 8.8 7 11 7m0-2c-3.4-.1-6.2 2.6-6.2 6s2.6 6.2 6 6.2c3.4.1 6.2-2.6 6.2-6v-.1C17 7.8 14.3 5 11 5zM17 3.5c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1z"
              />
            </symbol>
            <symbol viewBox="0 0 512 512" id="icon-logout">
              <path
                className="st0"
                d="M255.1 468.6H63.8c-11.7 0-21.3-9.5-21.3-21.3V64.6c0-11.7 9.5-21.3 21.3-21.3h191.4c11.8 0 21.3-9.5 21.3-21.3S267 .7 255.2.7H63.8C28.6.8 0 29.5 0 64.6v382.7c0 35.2 28.6 63.8 63.8 63.8h191.4c11.8 0 21.3-9.5 21.3-21.3s-9.6-21.2-21.4-21.2z"
              />
              <path
                className="st0"
                d="M505.7 240.9L376.4 113.3c-8.3-8.3-21.8-8.1-30.1.2s-8.2 21.8.2 30.1l92.4 91.2H191.4c-11.8 0-21.3 9.5-21.3 21.3s9.5 21.3 21.3 21.3H439l-92.4 91.2c-8.4 8.3-8.4 21.7-.2 30.1 4.2 4.2 9.7 6.3 15.1 6.3s10.8-2 14.9-6.1l129.3-127.6c4-4 6.3-9.4 6.3-15.1 0-5.9-2.3-11.3-6.3-15.3z"
              />
            </symbol>
            <symbol viewBox="0 0 512 512" id="icon-percent">
              <path d="M375.5 213.3c-34 0-66.8 12.8-91.8 35.8-13-11.2-31.4-13.5-46.8-5.9s-24.6 23.8-23.5 40.9 12.4 31.9 28.6 37.5c-12 56.7 13 114.6 62.3 144.8s112.3 25.9 157.2-10.5 62-97.2 42.7-151.7-70.9-90.9-128.7-90.9zm-145.1 68.3c0-9.8 5.5-18.7 14.3-23 8.8-4.3 19.2-3.2 26.9 2.9-11 12.9-19.5 27.8-25.1 43.8-9.7-3.8-16.1-13.2-16.1-23.7zm145.1 187.7c-66 0-119.5-53.5-119.5-119.5s53.5-119.5 119.5-119.5S495 283.8 495 349.8c-.1 66-53.6 119.5-119.5 119.5zM454 217.7c3.5 3.1 8.9 2.8 12-.7 37.1-42.1 38.5-104.8 3.3-148.5s-96.9-55.6-145.8-28.2c-2.7 1.5-4.4 4.3-4.5 7.3-.1 3.1 1.5 5.9 4.2 7.5s5.9 1.6 8.6 0c41.7-23.4 94.3-13.3 124.3 23.9s28.8 90.7-2.9 126.6c-3 3.6-2.7 8.9.8 12.1zM200.5 435.2c10.8 0 21.6-.8 32.2-2.6 3.1-.4 5.7-2.5 6.8-5.4s.6-6.2-1.4-8.5c-2-2.4-5.1-3.5-8.1-3-9.8 1.6-19.6 2.3-29.5 2.3-70.9 0-135.4-40.8-165.8-104.9s-21-139.8 23.9-194.6c3-3.6 2.4-9-1.2-12-3.6-3-9-2.5-12 1.1-49.1 60-59.2 142.8-26.1 212.9S123 435.2 200.5 435.2z" />
              <path d="M378.5 190.2c.9 3.8 4.4 6.5 8.3 6.5.7 0 1.4-.1 2.1-.2 4.6-1.1 7.4-5.8 6.2-10.3-22.3-89.3-102.5-152-194.6-152-43.4-.1-85.7 14-120.3 40.1-3.8 2.8-4.5 8.2-1.7 11.9 2.8 3.8 8.2 4.5 11.9 1.7C150.2 43.1 231.2 39 295.3 77.6c41.4 25.1 71.4 65.6 83.2 112.6z" />
              <path d="M113.4 321.8c3.3 3.3 8.7 3.3 12.1 0l170.7-170.7c3.2-3.3 3.2-8.7-.1-12-3.3-3.3-8.6-3.3-12-.1L113.4 309.7c-3.3 3.3-3.3 8.7 0 12.1zM153.6 221.9c23.6 0 42.7-19.1 42.7-42.7s-19.1-42.7-42.7-42.7-42.7 19.1-42.7 42.7c.1 23.6 19.1 42.6 42.7 42.7zm0-68.3c14.1 0 25.6 11.5 25.6 25.6s-11.5 25.6-25.6 25.6-25.6-11.5-25.6-25.6 11.5-25.6 25.6-25.6z" />
            </symbol>
            <symbol viewBox="0 0 310 218.2" id="icon-play">
              <path d="M297.9 18.7C286.7 5.4 266.1 0 226.6 0H83.4C43 0 22 5.8 10.9 19.9 0 33.7 0 54.1 0 82.2v53.7c0 54.6 12.9 82.2 83.4 82.2h143.2c34.2 0 53.2-4.8 65.4-16.5 12.6-12 17.9-31.7 17.9-65.7V82.2c.1-29.6-.7-50.1-12-63.5zM199 116.5l-65 34c-1.5.8-3 1.1-4.6 1.1-1.8 0-3.6-.5-5.2-1.4-3-1.8-4.8-5.1-4.8-8.6V73.9c0-3.5 1.8-6.7 4.8-8.5 3-1.8 6.7-1.9 9.8-.3l65 33.8c3.3 1.7 5.4 5.1 5.4 8.9 0 3.5-2.1 7-5.4 8.7z" />
            </symbol>
            <symbol viewBox="0 0 512 512" id="icon-question">
              <path d="M437.02 74.98C388.668 26.63 324.379 0 256 0 194.445 0 134.96 22.16 88.5 62.402a7.603 7.603 0 0 0-.77 10.727 7.603 7.603 0 0 0 10.727.77C142.152 36.05 198.102 15.206 256 15.206c64.316 0 124.785 25.047 170.266 70.527S496.793 191.684 496.793 256s-25.047 124.785-70.527 170.266S320.316 496.793 256 496.793s-124.785-25.047-170.266-70.527S15.207 320.316 15.207 256c0-59.824 22.082-117.176 62.184-161.484 2.816-3.114 2.574-7.922-.54-10.743a7.6 7.6 0 0 0-10.738.54C23.48 131.422 0 192.394 0 256c0 68.379 26.629 132.668 74.98 181.02C123.332 485.37 187.621 512 256 512s132.668-26.629 181.02-74.98C485.37 388.668 512 324.379 512 256s-26.629-132.668-74.98-181.02zm0 0" />
              <path d="M246.332 347.125c-23.48 0-42.586 19.313-42.586 43.047s19.106 43.047 42.586 43.047c11.527 0 22.383-4.586 30.566-12.918 7.93-8.074 12.48-19.055 12.48-30.13 0-11.378-4.51-22.155-12.698-30.347-8.192-8.187-18.97-12.699-30.348-12.699zm0 70.887c-15.098 0-27.379-12.489-27.379-27.84s12.281-27.84 27.379-27.84c15.09 0 27.836 12.75 27.836 27.84s-12.746 27.84-27.836 27.84zm0 0M319.605 228.371a7.602 7.602 0 0 0 10.73-.726c18.325-20.993 27.618-42.97 27.618-65.317 0-23.566-10.586-44.93-29.805-60.152-19.32-15.301-45.539-23.387-75.828-23.387-37.468 0-60.644 12.649-73.484 23.258-15.527 12.828-24.8 30.031-24.8 46.016 0 10.39 4.253 19.542 11.98 25.773 6.359 5.129 14.828 8.07 23.242 8.07 14.496 0 20.851-9.37 25.957-16.902 6.469-9.535 12.574-18.543 35.719-18.543 7.933 0 33.82 1.71 33.82 23.695 0 16.594-15.34 28.371-28.875 38.762-3.344 2.562-6.5 4.988-9.445 7.488-15.586 13.434-33.48 34.184-33.48 75.727 0 23.074 5.597 38.445 32.921 38.445 12.102 0 21.238-2.742 27.156-8.148 4.969-4.54 7.598-10.88 7.598-18.336 0-22.414 0-33.664 22.86-51.543l.39-.305a242.783 242.783 0 0 0 3.453-2.73 7.602 7.602 0 0 0 1.145-10.692 7.602 7.602 0 0 0-10.692-1.144c-1.215.98-2.312 1.836-3.262 2.578l-.402.312c-27.367 21.407-28.7 37.293-28.7 63.528 0 3.37 0 11.273-19.546 11.273-9.547 0-12.453-1.996-13.918-3.738-2.555-3.035-3.797-9.414-3.797-19.5 0-35.16 14.258-52.188 28.156-64.168 2.621-2.223 5.633-4.535 8.825-6.985 15.511-11.91 34.824-26.734 34.824-50.824 0-23.633-19.246-38.902-49.031-38.902-31.204 0-41.086 14.574-48.305 25.215-4.934 7.277-7.184 10.23-13.371 10.23-8.043 0-20.012-4.965-20.012-18.637 0-8.878 5.063-22.55 19.277-34.292 10.922-9.02 30.852-19.778 63.801-19.778 53.242 0 90.422 28.102 90.422 68.336 0 18.563-8.027 37.172-23.863 55.317a7.6 7.6 0 0 0 .722 10.726zm0 0" />
            </symbol>
            <symbol viewBox="0 0 491.001 491.001" id="icon-scheme">
              <path d="M470.3 337.05h-52.1v-93.8c0-11.5-9.4-20.9-20.9-20.9H265.9v-69.9H317c11.5 0 19.8-8.3 20.9-19.8V21.25c0-11.5-9.4-20.9-20.9-20.9H173.1c-11.5 0-20.9 9.4-20.9 20.9v110.5c0 11.5 9.4 20.9 20.9 20.9h51.1v69.9H91.8c-11.5 0-20.9 9.4-20.9 20.9v93.8h-50c-11.5 0-20.9 9.4-20.9 20.9v111.6c0 11.5 9.4 20.9 20.9 20.9h142.8c11.5 0 20.9-9.4 21.9-20.9v-111.8c0-11.5-9.4-20.9-20.9-20.9h-52.1v-74h264.8v74h-51.1c-11.5 0-20.9 9.4-20.9 20.9v111.6c0 11.5 9.4 20.9 20.9 20.9h142.8c11.5 0 20.9-9.4 21.9-20.9v-111.6c.1-11.5-9.3-20.9-20.7-20.9zM194 41.05h103.2v70.9H194v-70.9zm-50 408.6H40.7v-70.9h103.2v70.9h.1zm305.4 0H346.2v-70.9h103.2v70.9z" />
            </symbol>
            <symbol viewBox="0 0 74 74" id="icon-settings">
              <path d="M41.074 72h-8.148a1.989 1.989 0 0 1-1.978-1.7l-.855-5.731a28.157 28.157 0 0 1-7.7-3.19l-4.66 3.448a2.012 2.012 0 0 1-2.6-.193l-5.762-5.766a2.011 2.011 0 0 1-.193-2.6l3.447-4.659a28.177 28.177 0 0 1-3.19-7.7l-5.73-.856A2.012 2.012 0 0 1 2 41.074v-8.148a2.012 2.012 0 0 1 1.705-1.978l5.73-.856a28.165 28.165 0 0 1 3.19-7.7l-3.447-4.656a2.013 2.013 0 0 1 .193-2.605l5.761-5.76a2.013 2.013 0 0 1 2.6-.194l4.668 3.448a28.157 28.157 0 0 1 7.7-3.19l.848-5.735A1.989 1.989 0 0 1 32.926 2h8.148a1.989 1.989 0 0 1 1.978 1.7l.855 5.731a28.157 28.157 0 0 1 7.7 3.19l4.66-3.448a2.012 2.012 0 0 1 2.6.193l5.761 5.762a2.011 2.011 0 0 1 .193 2.6l-3.447 4.658a28.165 28.165 0 0 1 3.19 7.7l5.73.856A2.012 2.012 0 0 1 72 32.926v8.148a2.012 2.012 0 0 1-1.7 1.978l-5.73.856a28.177 28.177 0 0 1-3.19 7.7l3.447 4.659a2.013 2.013 0 0 1-.193 2.6l-5.761 5.76a2.01 2.01 0 0 1-2.6.194l-4.659-3.448a28.157 28.157 0 0 1-7.7 3.19l-.862 5.737a1.989 1.989 0 0 1-1.978 1.7zm-18.73-12.832a1 1 0 0 1 .535.156 26.2 26.2 0 0 0 8.321 3.449 1 1 0 0 1 .771.828l.956 6.4h8.147l.955-6.4a1 1 0 0 1 .771-.828 26.2 26.2 0 0 0 8.321-3.449 1 1 0 0 1 1.13.041l5.2 3.85 5.761-5.761-3.85-5.2a1 1 0 0 1-.041-1.13 26.191 26.191 0 0 0 3.451-8.324 1 1 0 0 1 .829-.771l6.4-.955v-8.148l-6.4-.955a1 1 0 0 1-.829-.771 26.206 26.206 0 0 0-3.448-8.322 1 1 0 0 1 .041-1.129l3.85-5.2-5.761-5.761-5.2 3.85a1 1 0 0 1-1.13.041 26.2 26.2 0 0 0-8.324-3.452 1 1 0 0 1-.771-.828L41.073 4h-8.147l-.955 6.4a1 1 0 0 1-.771.828 26.2 26.2 0 0 0-8.321 3.449 1 1 0 0 1-1.13-.041l-5.2-3.85-5.761 5.761 3.85 5.2a1 1 0 0 1 .041 1.129 26.206 26.206 0 0 0-3.451 8.324 1 1 0 0 1-.829.771L4 32.926v8.148l6.4.955a1 1 0 0 1 .829.771 26.191 26.191 0 0 0 3.448 8.321 1 1 0 0 1-.041 1.13l-3.85 5.2 5.761 5.761 5.2-3.85a1 1 0 0 1 .597-.194z" />
              <path d="M44.05 55.911a1 1 0 0 1-.357-1.935 15.725 15.725 0 0 0 2.623-1.288 1 1 0 1 1 1.047 1.7 17.752 17.752 0 0 1-2.957 1.452.989.989 0 0 1-.356.071zM35.421 57.18h-.082A20.248 20.248 0 1 1 57.25 37c0 .672-.032 1.343-.095 2a1 1 0 1 1-1.99-.192c.057-.589.085-1.2.085-1.8A18.25 18.25 0 1 0 35.5 55.184a1 1 0 0 1-.08 2zM52.109 49.91a1 1 0 0 1-.777-1.628 17.106 17.106 0 0 0 1.587-2.343 1 1 0 1 1 1.742.982 19.069 19.069 0 0 1-1.772 2.617 1 1 0 0 1-.78.372z" />
            </symbol>
            <symbol viewBox="0 0 74 74" id="icon-shield">
              <path d="M57.169 52.04a1 1 0 0 1-.868-1.495c.523-.917.955-1.749 1.321-2.544a1 1 0 0 1 1.816.837 35.12 35.12 0 0 1-1.4 2.7 1 1 0 0 1-.869.502z" />
              <path d="M37.2 72a.994.994 0 0 1-.505-.137C20.18 62.2 10.271 46.537 10.19 29.965l-.02-18.234a1 1 0 0 1 .309-.723 1.043 1.043 0 0 1 .735-.277c9.146.4 17.387-2.381 25.167-8.516a1 1 0 0 1 1.253.012C44.3 7.7 52.539 10.405 62.819 10.51a1 1 0 0 1 .991 1l.02 18.431c0 .7-.021 1.4-.062 2.09a1 1 0 0 1-2-.119c.04-.651.059-1.311.059-1.971l-.019-17.448c-9.986-.263-18.123-2.957-24.822-8.218-7.69 5.876-15.836 8.653-24.818 8.488l.019 17.2c.08 15.68 9.413 30.548 25.013 39.872a55.711 55.711 0 0 0 15.12-13.318 1 1 0 1 1 1.58 1.226 57.865 57.865 0 0 1-16.187 14.115.99.99 0 0 1-.513.142z" />
              <path d="M61.08 42.871a1 1 0 0 1-.959-1.284c.27-.915.517-1.86.734-2.81a1 1 0 1 1 1.95.446c-.227.99-.485 1.976-.766 2.93a1 1 0 0 1-.959.718zM30.75 44a1 1 0 0 1-.707-.293l-7.5-7.5a1 1 0 0 1 1.414-1.414l6.793 6.793 19.293-19.293a1 1 0 0 1 1.414 1.414l-20 20a1 1 0 0 1-.707.293z" />
            </symbol>
            <symbol viewBox="0 0 511.96 511.96" id="icon-telegram">
              <path d="M371.763 511.892c-15.619 0-31.121-4.567-44.594-13.531l-107.352-71.428c-9.196-6.119-11.69-18.534-5.572-27.73 6.119-9.195 18.535-11.691 27.73-5.572l107.352 71.428c11.664 7.762 25.729 9.025 38.587 3.467 12.858-5.556 21.576-16.662 23.917-30.471l59.454-350.679c2.544-15.007-3.121-29.532-15.154-38.854-12.035-9.323-27.517-11.178-41.416-4.966L63.912 200.41c-13.698 6.125-22.621 18.707-23.869 33.657-1.249 14.951 5.463 28.839 17.955 37.15l48.979 32.588c9.196 6.119 11.69 18.534 5.572 27.73-6.119 9.194-18.535 11.69-27.73 5.572L35.84 304.52c-52.669-33.74-45.777-116.101 11.745-140.626L398.387 7.039a80.447 80.447 0 0 1 82.24 9.86 80.44 80.44 0 0 1 30.096 77.161l-59.454 350.679c-4.58 27.017-22.333 49.635-47.487 60.504-10.302 4.451-21.189 6.649-32.019 6.649zM173.897 491.96v-92.351c0-17.991 7.33-35.572 20.111-48.234l187.964-186.207c7.848-7.773 7.907-20.437.133-28.283-7.773-7.847-20.438-7.908-28.283-.133L165.857 322.959c-20.311 20.122-31.96 48.06-31.96 76.65v92.351c0 11.046 8.954 20 20 20s20-8.954 20-20z" />
            </symbol>
            <symbol viewBox="0 0 512 512" id="icon-triangles">
              <path d="M510.855 355.115L333.625 20.347a9.848 9.848 0 0 0-8.615-5.24c-3.154.005-6.952 1.918-8.702 5.082l-61.49 111.149L195.77 20.16c-1.711-3.212-5.048-5.39-8.692-5.39h-.01c-3.644 0-6.99 2.188-8.692 5.409L1.145 355.031c-1.615 3.053-1.519 6.6.269 9.557 1.779 2.961 4.981 4.643 8.433 4.643h88.615a9.844 9.844 0 0 0 9.846-9.846 9.843 9.843 0 0 0-9.846-9.846H26.203L187.097 45.79l56.355 106.021L60.309 482.914c-1.692 3.048-1.635 6.617.135 9.618 1.769 3.005 5 4.698 8.481 4.698H433.23c3.452 0 6.663-1.644 8.442-4.606a9.69 9.69 0 0 0 .25-9.613l-41.49-77.962c-2.558-4.798-8.529-6.608-13.317-4.046-4.798 2.552-6.625 8.356-4.067 13.159l33.788 63.376H85.626l168.855-305.076 74.711 140.54c2.548 4.793 8.509 6.653 13.317 4.109 4.798-2.553 6.625-8.494 4.067-13.297l-80.721-151.748L324.73 45.462l161.066 304.075h-298.72a9.844 9.844 0 0 0-9.846 9.846 9.843 9.843 0 0 0 9.846 9.846h315.075c3.452 0 6.654-1.639 8.433-4.601 1.79-2.955 1.886-6.46.271-9.513z" />
            </symbol>
            <symbol viewBox="0 0 512 512" id="icon-unlock">
              <path d="M255.999 0c-79.044 0-143.352 64.308-143.352 143.353v70.193c0 4.78 3.879 8.656 8.659 8.656h48.057a8.657 8.657 0 0 0 8.656-8.656v-70.193c0-42.998 34.981-77.98 77.979-77.98s77.979 34.982 77.979 77.98v70.193c0 4.78 3.88 8.656 8.661 8.656h48.057a8.657 8.657 0 0 0 8.656-8.656v-70.193C399.352 64.308 335.044 0 255.999 0zM382.04 204.89h-30.748v-61.537c0-52.544-42.748-95.292-95.291-95.292s-95.291 42.748-95.291 95.292v61.537h-30.748v-61.537c0-69.499 56.54-126.04 126.038-126.04 69.499 0 126.04 56.541 126.04 126.04v61.537z" />
              <path d="M410.63 204.89H101.371c-20.505 0-37.188 16.683-37.188 37.188v232.734c0 20.505 16.683 37.188 37.188 37.188H410.63c20.505 0 37.187-16.683 37.187-37.189V242.078c0-20.505-16.682-37.188-37.187-37.188zm19.875 269.921c0 10.96-8.916 19.876-19.875 19.876H101.371c-10.96 0-19.876-8.916-19.876-19.876V242.078c0-10.96 8.916-19.876 19.876-19.876H410.63c10.959 0 19.875 8.916 19.875 19.876v232.733z" />
              <path d="M285.11 369.781c10.113-8.521 15.998-20.978 15.998-34.365 0-24.873-20.236-45.109-45.109-45.109-24.874 0-45.11 20.236-45.11 45.109 0 13.387 5.885 25.844 16 34.367l-9.731 46.362a8.66 8.66 0 0 0 8.472 10.436h60.738a8.654 8.654 0 0 0 8.47-10.434l-9.728-46.366zm-14.259-10.961a8.658 8.658 0 0 0-3.824 9.081l8.68 41.366h-39.415l8.682-41.363a8.655 8.655 0 0 0-3.824-9.081c-8.108-5.16-12.948-13.911-12.948-23.406 0-15.327 12.469-27.796 27.797-27.796 15.327 0 27.796 12.469 27.796 27.796.002 9.497-4.838 18.246-12.944 23.403z" />
            </symbol>
            <symbol viewBox="0 0 512 512" id="icon-wallet-copy">
              <path d="M464.7 256.3c-4.5 0-8.2-3.7-8.2-8.2V145h-82.2c-4.5 0-8.2-3.7-8.2-8.2 0-4.5 3.7-8.2 8.2-8.2h90.4c4.5 0 8.2 3.7 8.2 8.2v111.3c0 4.6-3.7 8.2-8.2 8.2zM464.7 473.9H82.4c-38.6 0-69.8-31.3-69.9-69.9V91.6c0-4.5 3.7-8.2 8.2-8.2 4.5 0 8.2 3.7 8.2 8.2V404c0 29.5 23.9 53.4 53.4 53.4h374.1V346.8c0-4.5 3.7-8.2 8.2-8.2 4.5 0 8.2 3.7 8.2 8.2v118.9c.1 4.5-3.6 8.2-8.1 8.2z" />
              <path d="M483 355H375.6c-31.8 0-57.5-25.8-57.5-57.5s25.8-57.5 57.5-57.5H483c9.1 0 16.4 7.4 16.4 16.4v82.2c.1 9-7.3 16.4-16.4 16.4zm0-98.7H375.6c-22.7 0-41.1 18.4-41.1 41.1 0 22.7 18.4 41.1 41.1 41.1H483v-82.2zM374.3 145H66c-29.5 0-53.4-23.9-53.4-53.4S36.5 38.1 66 38.1h300c9.1 0 16.5 7.4 16.5 16.5v82.1c0 4.6-3.7 8.3-8.2 8.3zM66 54.6c-20.4 0-37 16.6-37 37s16.6 37 37 37h300V54.7l-300-.1z" />
              <path d="M374.3 99.8H101.7c-4.5 0-8.2-3.7-8.2-8.2 0-4.5 3.7-8.2 8.2-8.2h272.6c4.5 0 8.2 3.7 8.2 8.2 0 4.5-3.7 8.2-8.2 8.2zM382.8 322.8c-15.2 0-27.5-12.3-27.5-27.5s12.3-27.5 27.5-27.5 27.5 12.3 27.5 27.5-12.3 27.5-27.5 27.5zm0-40.4c-7.2 0-13 5.8-13 13s5.8 13 13 13 13-5.8 13-13-5.8-13-13-13z" />
            </symbol>
            <symbol viewBox="0 0 471.9 379.6" id="icon-youtube">
              <path d="M456.3 66.7c-6.6-25-25.9-44.6-50.5-51.3C380.4 8.5 333.2 5.9 278.3 5c-5.5-.1-10.1 4.3-10.2 9.8s4.3 10.1 9.8 10.2c76 1.3 104.3 4.7 122.6 9.7 17.7 4.8 31.7 19 36.5 37.1 9.8 37.3 10 117 10 117.8 0 .8-.1 80.5-10 117.8-4.8 18.1-18.7 32.3-36.5 37.1-36.7 10-138 10.1-139.5 10.1s-152.9-.1-189.6-10.1c-17.7-4.8-31.7-19-36.5-37.1-9.8-37.3-9.9-117-9.9-117.8s.1-80.5 10-117.8c4.8-18.1 18.7-32.3 36.5-37.1 18.6-5.1 21.1-8.5 99.4-9.7 5.5-.1 9.9-4.6 9.8-10.2-.1-5.5-4.6-9.9-10.2-9.8-56.6.9-78.4 3.4-104.3 10.4-24.6 6.7-44 26.3-50.5 51.3C5.1 106.5 5 186.2 5 189.6s.1 83.1 10.6 122.9c6.6 25 25.9 44.6 50.5 51.3 39.3 10.7 188.6 10.8 194.9 10.8 6.3 0 105.5-.1 144.7-10.8 24.6-6.7 44-26.3 50.5-51.3 10.6-39.8 10.7-119.5 10.7-122.9s-.1-83.1-10.6-122.9z" />
              <path d="M261 379.6c-6.4 0-156.4-.1-196.2-11-26.3-7.2-47-28.2-54-54.8C.1 273.4 0 193 0 189.6s.1-83.8 10.9-124.2c6.9-26.6 27.6-47.6 54-54.8C92.3 3.2 115 .9 170.4 0c8.3-.1 15.1 6.5 15.3 14.7.1 8.3-6.4 15.1-14.7 15.3-69 1.1-78.3 3.8-92.4 7.9-1.8.5-3.7 1.1-5.7 1.6-16 4.3-28.6 17.2-33 33.6-9.8 36.6-9.9 115.7-9.9 116.5s.1 79.9 9.7 116.5c4.3 16.3 17 29.2 33 33.5 36 9.8 186.8 9.9 188.3 9.9 1 0 102.2-.1 138.2-9.9 16-4.3 28.6-17.2 33-33.6 9.7-36.6 9.8-115.7 9.8-116.5 0-.8-.3-80.1-9.8-116.5-4.3-16.3-17-29.2-33-33.5-17.5-4.8-44.8-8.2-121.4-9.5-4-.1-7.7-1.7-10.5-4.6-2.8-2.9-4.3-6.7-4.2-10.7.1-4 1.7-7.7 4.6-10.5 2.8-2.7 6.5-4.2 10.4-4.2h.3c65.2 1.1 106.1 4.4 128.7 10.6 26.3 7.2 47 28.2 54 54.8 10.6 40.3 10.8 120.8 10.8 124.2 0 3.4-.1 83.8-10.9 124.2-6.9 26.6-27.6 47.6-54 54.8-39.1 10.7-135.2 11-146 11zM170.7 10s-.1 0 0 0c-54.5.9-76.7 3.1-103.2 10.2-22.9 6.2-40.9 24.5-47 47.7C10.1 107.1 10 186.3 10 189.6c0 3.4.1 82.5 10.4 121.6 6.1 23.2 24.1 41.5 47 47.8 38.6 10.5 187.3 10.6 193.6 10.6 10.7 0 105.6-.3 143.4-10.6 22.9-6.2 40.9-24.5 47-47.7 10.4-39.1 10.5-118.3 10.5-121.6 0-3.4-.1-82.5-10.4-121.6-6.1-23.2-24.1-41.5-47-47.8-21.8-5.9-61.9-9.2-126.3-10.2-1.3 0-2.6.5-3.6 1.4-1 .9-1.5 2.2-1.5 3.5 0 1.3.5 2.6 1.4 3.6.9 1 2.2 1.5 3.5 1.5 77.6 1.3 105.6 4.9 123.8 9.9 19.4 5.3 34.8 20.8 40 40.6 10.1 38.3 10.2 118.3 10.2 119.1 0 .8-.1 81.2-10.2 119.1-5.3 19.8-20.6 35.4-40 40.6-37.3 10.2-136.6 10.3-140.8 10.3-1.5 0-153.6-.1-190.9-10.3-19.4-5.3-34.8-20.8-40-40.6-10-38-10.1-118.4-10.1-119.2s.1-81.2 10.2-119.1c5.3-19.8 20.6-35.4 40-40.6 2-.5 3.8-1.1 5.6-1.6 14.9-4.3 24.7-7.2 95.1-8.3 2.8-.1 4.9-2.3 4.9-5.1-.1-2.8-2.3-4.9-5.1-4.9z" />
              <g>
                <path d="M324.8 182.5l-124-72c-3.1-1.8-6.9-1.8-10 0s-5 5.1-5 8.7v144c0 3.6 1.9 6.9 5 8.7 1.5.9 3.3 1.3 5 1.3s3.5-.5 5-1.4l124-72c3.1-1.8 5-5.1 5-8.6s-1.9-6.9-5-8.7zm-119 63.3V136.5l94.1 54.6-94.1 54.7z" />
                <path d="M195.8 278.2c-2.8 0-5.4-.7-7.6-2-4.6-2.6-7.4-7.6-7.4-13v-144c0-5.4 2.9-10.3 7.5-13 4.6-2.7 10.4-2.7 15 0l124 72c4.6 2.7 7.5 7.7 7.5 13s-2.9 10.2-7.5 12.9l-124 72c-2.2 1.4-4.9 2.1-7.5 2.1zm0-164.1c-.9 0-1.7.2-2.5.7-1.6.9-2.5 2.5-2.5 4.4v144c0 1.8.9 3.5 2.5 4.4.7.4 1.6.6 2.5.6.8 0 1.7-.3 2.4-.7l124.1-72c1.5-.9 2.5-2.5 2.5-4.3 0-1.8-1-3.5-2.5-4.4l-124-72c-.8-.4-1.6-.7-2.5-.7zm5 140.4V127.8l109.1 63.3-109.1 63.4zm10-109.3v91.9l79.1-46-79.1-45.9z" />
              </g>
            </symbol>
          </svg>
        </div>
        <div className="loader hide">
          <img src="assets/images/spinner.svg" alt="" />
        </div>
        <main className="wrapper" id="app">
          {/* Profile layout*/}
          <div className="profile-layout js-sticky-wrapper">
            {/* sidebar*/}
 <Navbar/>
            {/* Wrapper*/}
            <div className="profile-layout__wrapper">
              <header className="header-profile">
                <div className="container">
                  <div className="header-profile__row">
                    <a className="header-profile__logo" href="index.html">
                      <img src="assets/images/logo/logo.png" alt="" />
                    </a>
                    <h4 className="header-profile__slogan">
                      Crypto Investments{" "}
                    </h4>
                    <div className="header-profile__right">
                      <div className="total-balance">
                        Total Balance <span>$ 0.00</span>
                      </div>
                      <div className="select-language js-dropdown">
                        <a className="select-language__link">
                          <span>EN</span>
                        </a>
                        <div className="select-language__dropdown">
                          <ul>
                            <li>
                              <a href="?language=en">ENGLISH </a>
                            </li>
                            <li>
                              <a href="?language=es">SPANISH </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <a className="link-icon" href="?a=account">
                        <svg className="svg-icon">
                          <use href="assets/icons/sprite.svg#icon-003-shield" />
                        </svg>
                        <span>{userdetails.fullname}</span>
                      </a>
                    </div>
                  </div>
                </div>
                {/* <div className="hamburger" onClick={navslide}>
                  <span className="line" />
                  <span className="line" />
                  <span className="line" />
                </div> */}
              </header>
              <article className="profile-layout__content">
                {/* Begin page*/}
                <section>
                  <div className="container">
                    <div className="account-statistics">
                      <div className="swiper-container js-swiper-statistics swiper-no-swiping swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events swiper-container-free-mode">
                        <div
                          className="swiper-wrapper"
                          id="swiper-wrapper-f8e6ddc9fc297d82"
                          aria-live="polite"
                        >
                          <div
                            className="swiper-slide swiper-slide-active"
                            role="group"
                            aria-label="1 / 4"
                            style={{ width: "284.6px", marginRight: "15px" }}
                          >
                            <div className="account-statistics-item">
                              <p className="account-statistics-item__title">
                                Total <strong>Invested</strong>
                              </p>
                              <p className="account-statistics-item__value">
                                {userdetails.TotalDeposit}
                                <sub>$</sub>
                              </p>
                            </div>
                          </div>
                          <div
                            className="swiper-slide swiper-slide-next"
                            role="group"
                            aria-label="2 / 4"
                            style={{ width: "284.6px", marginRight: "15px" }}
                          >
                            <div className="account-statistics-item">
                              <p className="account-statistics-item__title">
                                Active <strong>Deposit</strong>
                              </p>
                              <p className="account-statistics-item__value">
                                {userdetails.Totaldeposit}
                                <sub>$</sub>
                              </p>
                            </div>
                          </div>

                          <div
                            className="swiper-slide"
                            role="group"
                            aria-label="4 / 4"
                            style={{ width: "284.6px", marginRight: "15px" }}
                          >
                            <div className="account-statistics-item">
                              <p className="account-statistics-item__title">
                                Total <strong>Withdrawn</strong>
                              </p>
                              <p className="account-statistics-item__value">
                                {userdetails.Totalwithdrawal}
                                <sub>$</sub>
                              </p>
                            </div>
                          </div>
                        </div>
                        <span
                          className="swiper-notification"
                          aria-live="assertive"
                          aria-atomic="true"
                        />
                      </div>
                    </div>
                  </div>
                </section>
                <style
                  dangerouslySetInnerHTML={{
                    __html:
                      "\n                        .sbmt {\n                            color: #000;\n                            background-image: -webkit-gradient(linear, left top, right top, from(#40efeb), to(#9ed163));\n                            background-image: -o-linear-gradient(left, #40efeb 0, #9ed163 100%);\n                            background-image: linear-gradient(90deg, #40efeb, #9ed163) padding: 0 30px;\n                            color: #000;\n                            background-color: #dbdddc;\n                            font-size: 15px;\n                            font-family: Manrope,\n                                sans-serif;\n                            cursor: pointer;\n                            display: -webkit-inline-box;\n                            display: -ms-inline-flexbox;\n                            display: inline-flex;\n                            -webkit-box-pack: center;\n                            -ms-flex-pack: center;\n                            justify-content: center;\n                            -webkit-box-align: center;\n                            -ms-flex-align: center;\n                            align-items: center;\n                            vertical-align: top;\n                            text-decoration: none;\n                            position: relative;\n                            border-radius: 6px;\n                            text-transform: uppercase;\n                            height: 40px;\n                            font-weight: 700;\n                            text-align: center;\n                            cursor: pointer;\n                        }\n\n                    ",
                  }}
                />

                <section>
                  <form method="post" name="spendform">
                    <div className="container">
                      {step == 1 && (
                        <div className="profile-block">
                          <div className="profile-block__top">
                            <h4 className="title-module">
                              Select a payment system{" "}
                            </h4>
                          </div>
                          <div className="profile-block__content">
                            <div className="select-payment">
                              <ul>
                                <li
                                  onClick={() => {
                                    SetCoinInfo("1");
                                  }}
                                >
                                  <label className="checkbox-label">
                                    <input
                                      type="radio"
                                      name="type"
                                      defaultValue="process_1000"
                                      defaultChecked
                                    />
                                    <span className="checkbox-label__content">
                                      <span className="checkbox-label__icon">
                                        <svg className="svg-icon">
                                          <use href="assets/icons/sprite.svg#icon-check" />
                                        </svg>
                                      </span>
                                      <p className="checkbox-label__name">
                                        BITCOIN{" "}
                                      </p>
                                      <span className="checkbox-label__image">
                                        <img
                                          src="img/ps/ico/svg/1000.svg"
                                          alt=""
                                          style={{ height: "30px" }}
                                        />
                                      </span>
                                    </span>
                                  </label>
                                </li>
                                <li
                                  onClick={() => {
                                    SetCoinInfo("2");
                                  }}
                                >
                                  <label className="checkbox-label">
                                    <input
                                      type="radio"
                                      name="type"
                                      defaultValue="process_1003"
                                    />
                                    <span className="checkbox-label__content">
                                      <span className="checkbox-label__icon">
                                        <svg className="svg-icon">
                                          <use href="assets/icons/sprite.svg#icon-check" />
                                        </svg>
                                      </span>
                                      <p className="checkbox-label__name">
                                        ETHEREUM{" "}
                                      </p>
                                      <span className="checkbox-label__image">
                                        <img
                                          src="img/ps/ico/svg/1003.svg"
                                          alt=""
                                          style={{ height: "30px" }}
                                        />
                                      </span>
                                    </span>
                                  </label>
                                </li>

                                <li
                                  onClick={() => {
                                    SetCoinInfo("4");
                                  }}
                                >
                                  <label className="checkbox-label">
                                    <input
                                      type="radio"
                                      name="type"
                                      defaultValue="process_1006"
                                    />
                                    <span className="checkbox-label__content">
                                      <span className="checkbox-label__icon">
                                        <svg className="svg-icon">
                                          <use href="assets/icons/sprite.svg#icon-check" />
                                        </svg>
                                      </span>
                                      <p className="checkbox-label__name">
                                        USDT{" "}
                                      </p>
                                      <span className="checkbox-label__image">
                                        <img
                                          src="img/ps/ico/svg/1006.svg"
                                          alt=""
                                          style={{ height: "30px" }}
                                        />
                                      </span>
                                    </span>
                                  </label>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      )}

                      {step == 2 && (
                        <>
                          <div className="profile-block">
                            <div className="profile-block__top">
                              <h4 className="title-module">
                                Choose a tariff plan{" "}
                              </h4>
                            </div>
                            <div className="profile-block__content">
                              <div className="select-deposit">
                                <ul>
                                  {investments.map((investment) => (
                                    <li
                                      onClick={() => {
                                        InvestmentInfo(investment.id);
                                      }}
                                      key={investment.id}
                                    >
                                      <label
                                        className="deposits-item"
                                        onClick={() => setstep(3)}
                                      >
                                        <input
                                          type="radio"
                                          name="h_id"
                                          defaultValue={investment.id}
                                        />
                                        <span className="deposits-item__content">
                                          <span className="deposits-item__count">
                                            <span className="deposits-item__count-number">
                                              {investment.profits}{" "}
                                            </span>
                                            <span className="deposits-item__count-content">
                                              <p className="deposits-item__count-sub">
                                                %
                                              </p>
                                              <p className="deposits-item__count-desc">
                                                Plan
                                              </p>
                                            </span>
                                          </span>
                                          <span className="deposits-item__item">
                                            <p className="deposits-item__item-title">
                                              Deposit:{" "}
                                              <span className="min_deposit">
                                                ${investment.minimum}.00
                                              </span>{" "}
                                              -{" "}
                                              <span className="max_deposit">
                                                ${investment.Maximum}.00
                                              </span>
                                            </p>
                                            <p
                                              className="deposits-item__item-value"
                                              id="minMoneyu2"
                                            ></p>
                                          </span>
                                          <span className="deposits-item__item deposits-item__item--earn">
                                            <p className="deposits-item__item-value">
                                              {investment.name}
                                              <sup
                                                style={{
                                                  fontSize: "20px",
                                                  margin: 0,
                                                }}
                                              >
                                                *
                                              </sup>
                                            </p>
                                          </span>
                                        </span>
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                      {step == 3 && (
                        <div>
                          <div className="profile-block">
                            <div className="profile-block__top">
                              <h4 className="title-module">Deposit Amount </h4>
                            </div>
                            <div className="profile-block__content">
                              <div className="field">
                                <div className="field__group">
                                  <input
                                    type="text"
                                    name="amount"
                                    onChange={(e) => {
                                      setAmount(e.target.value);
                                    }}
                                  />
                                  <label className="field__append">
                                    <span
                                      className="currency-marker"
                                      id="valut"
                                    />
                                  </label>
                                  {/* <button
                                className="btn btn--primary"
                                type="button"
                                onClick={() => setstep(step-1)}
                              >
                                back
                              </button> */}
                                </div>
                                <p id="ptext" style={{ color: "red" }} />
                              </div>
                            </div>
                          </div>
                          {Amount != 0 && (
                            <div
                              className="lk-buttons"
                              style={{ textAlign: "center" }}
                            >
                              <button
                                className="btn btn--primary"
                                type="button"
                                onClick={() => verifyDET()}
                              >
                                Next
                              </button>
                              <br />
                              <br />

                              <button
                                className="btn btn--primary"
                                type="button"
                                onClick={() => setstep(step - 1)}
                              >
                                back
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </form>
                </section>

                {step === 4 && (
                  <section>
                    <div className="container">
                      <div className="profile-block">
                        <div className="profile-block__top">
                          <h4 className="title-module">
                            Please confirm your deposit:
                          </h4>
                        </div>
                        <div className="table-wrap">
                          Please send your payments to this {CoinInfo.name}{" "}
                          account:{" "}
                          <p style={{ fontSize: "12px" }}>{CoinInfo.address}</p>
                          <br />
                          {/* Responsive QR Code Image */}
                          <img
                            // src={`https://api.qrserver.com/v1/create-qr-code/?data=${CoinInfo.address}&size=150x150`}
                            src={CoinInfo.src}
                            alt="QR Code"
                            style={{ maxWidth: "100%", height: "auto" }}
                          />
                          <br />
                          <form name="spend" method="post">
                            <input
                              type="button"
                              defaultValue="Confirm deposit"
                              className="sbmt"
                              onClick={handleUpload}
                            />{" "}
                            &nbsp;
                            <input
                              type="button"
                              className="sbmt"
                              defaultValue="Cancel"
                              onClick={() => setstep(1)}
                            />
                          </form>
                        </div>
                      </div>
                    </div>
                  </section>
                )}

                <div id="button-up" style={{ display: "none" }}>
                  <i className="fa fa-chevron-up" />
                </div>
                <link
                  rel="stylesheet"
                  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
                />
                <style
                  dangerouslySetInnerHTML={{
                    __html:
                      "\n    #button-up {\n        display: none;\n        position: fixed;\n        right: 20px;\n        bottom: 60px;\n        color: #000;\n        background-color: white;\n        text-align: center;\n        font-size: 30px;\n        padding: 3px 10px 10px 10px;\n        transition: .3s;\n        border-radius: 50px;\n        width: 50px;\n        height: 50px;\n        z-index: 9999;\n    }\n\n    #button-up:hover {\n        cursor: pointer;\n        background-color: #E8E8E8;\n        transition: .3s;\n    }\n\n",
                  }}
                />
                <section className="payments-logos">
                  <section className="payments-logos">
                    <div className="container">
                      <ul className="payments-logos__list">
                        <li>
                          <a href="#" target="_blank">
                            <img src="img/ps/svg/pmusd.svg" alt="" />
                          </a>
                        </li>
                        <li>
                          <a href="#" target="_blank">
                            <img src="img/ps/svg/btc.svg" alt="" />
                          </a>
                        </li>
                        <li>
                          <a href="#" target="_blank">
                            <img src="img/ps/svg/eth.svg" alt="" />
                          </a>
                        </li>
                        <li>
                          <a href="#" target="_blank">
                            <img src="img/ps/svg/ltc.svg" alt="" />
                          </a>
                        </li>
                        <li>
                          <a href="#" target="_blank">
                            <img src="img/ps/svg/doge.svg" alt="" />
                          </a>
                        </li>
                        <li>
                          <a href="#" target="_blank">
                            <img src="img/ps/svg/trx.svg" alt="" />
                          </a>
                        </li>
                        <li>
                          <a href="#" target="_blank">
                            <img src="img/ps/svg/usdttrc20.svg" alt="" />
                          </a>
                        </li>
                        <li>
                          <a href="#" target="_blank">
                            <img src="img/ps/svg/usdterc20.svg" alt="" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </section>
                  {/* End page  */}
                </section>
              </article>
              <footer className="footer">
                <div className="container">
                  <div className="footer__row">
                    <div className="footer__col">
                      <div className="footer__nav-row">
                        <div className="footer__nav-col">
                          <h4 className="footer-title">Menu </h4>
                          <ul className="footer__nav">
                            <li>
                              <a href="?a=about">About us </a>
                            </li>
                            <li>
                              <a href="?a=investments">Investments</a>
                            </li>
                            <li>
                              <a href="?a=faq">FAQ</a>
                            </li>
                            <li>
                              <a href="?a=support">Contacts</a>
                            </li>
                          </ul>
                        </div>
                        <div className="footer__nav-col">
                          <h4 className="footer-title">Actions </h4>
                          <ul className="footer__nav">
                            <li>
                              <a
                                className="text-gradient-strong"
                                href="?a=deposit"
                              >
                                Make a Deposit
                              </a>
                            </li>
                            <li>
                              <a
                                className="text-gradient-strong"
                                href="?a=statistic"
                              >
                                Statistics
                              </a>
                            </li>
                            <li>
                              <a
                                className="text-gradient-strong"
                                href="?a=login"
                              >
                                Login
                              </a>
                            </li>
                            <li>
                              {" "}
                              {/* google translate */}
                              <style
                                dangerouslySetInnerHTML={{
                                  __html:
                                    "\n    .goog-te-gadget{\n        font-size: 0px;\n    }\n    \n    #google_translate_element span{\n        display: none;\n    }\n    \n    select{\n        background: #203732;\n    }\n    \n    .goog-te-combo {\n        color: #fff;\n    }\n",
                                }}
                              />
                              <div>
                                <div id="google_translate_element">
                                  <div
                                    className="skiptranslate goog-te-gadget"
                                    dir="ltr"
                                    style={{}}
                                  >
                                    <div id=":0.targetLanguage">
                                      <select
                                        className="goog-te-combo"
                                        aria-label="Language Translate Widget"
                                      >
                                        <option value>Select Language</option>
                                        <option value="af">Afrikaans</option>
                                        <option value="sq">Albanian</option>
                                        <option value="am">Amharic</option>
                                        <option value="ar">Arabic</option>
                                        <option value="hy">Armenian</option>
                                        <option value="as">Assamese</option>
                                        <option value="ay">Aymara</option>
                                        <option value="az">Azerbaijani</option>
                                        <option value="bm">Bambara</option>
                                        <option value="eu">Basque</option>
                                        <option value="be">Belarusian</option>
                                        <option value="bn">Bengali</option>
                                        <option value="bho">Bhojpuri</option>
                                        <option value="bs">Bosnian</option>
                                        <option value="bg">Bulgarian</option>
                                        <option value="ca">Catalan</option>
                                        <option value="ceb">Cebuano</option>
                                        <option value="ny">Chichewa</option>
                                        <option value="zh-CN">
                                          Chinese (Simplified)
                                        </option>
                                        <option value="zh-TW">
                                          Chinese (Traditional)
                                        </option>
                                        <option value="co">Corsican</option>
                                        <option value="hr">Croatian</option>
                                        <option value="cs">Czech</option>
                                        <option value="da">Danish</option>
                                        <option value="dv">Dhivehi</option>
                                        <option value="doi">Dogri</option>
                                        <option value="nl">Dutch</option>
                                        <option value="eo">Esperanto</option>
                                        <option value="et">Estonian</option>
                                        <option value="ee">Ewe</option>
                                        <option value="tl">Filipino</option>
                                        <option value="fi">Finnish</option>
                                        <option value="fr">French</option>
                                        <option value="fy">Frisian</option>
                                        <option value="gl">Galician</option>
                                        <option value="ka">Georgian</option>
                                        <option value="de">German</option>
                                        <option value="el">Greek</option>
                                        <option value="gn">Guarani</option>
                                        <option value="gu">Gujarati</option>
                                        <option value="ht">
                                          Haitian Creole
                                        </option>
                                        <option value="ha">Hausa</option>
                                        <option value="haw">Hawaiian</option>
                                        <option value="iw">Hebrew</option>
                                        <option value="hi">Hindi</option>
                                        <option value="hmn">Hmong</option>
                                        <option value="hu">Hungarian</option>
                                        <option value="is">Icelandic</option>
                                        <option value="ig">Igbo</option>
                                        <option value="ilo">Ilocano</option>
                                        <option value="id">Indonesian</option>
                                        <option value="ga">Irish Gaelic</option>
                                        <option value="it">Italian</option>
                                        <option value="ja">Japanese</option>
                                        <option value="jw">Javanese</option>
                                        <option value="kn">Kannada</option>
                                        <option value="kk">Kazakh</option>
                                        <option value="km">Khmer</option>
                                        <option value="rw">Kinyarwanda</option>
                                        <option value="gom">Konkani</option>
                                        <option value="ko">Korean</option>
                                        <option value="kri">Krio</option>
                                        <option value="ku">
                                          Kurdish (Kurmanji)
                                        </option>
                                        <option value="ckb">
                                          Kurdish (Sorani)
                                        </option>
                                        <option value="ky">Kyrgyz</option>
                                        <option value="lo">Lao</option>
                                        <option value="la">Latin</option>
                                        <option value="lv">Latvian</option>
                                        <option value="ln">Lingala</option>
                                        <option value="lt">Lithuanian</option>
                                        <option value="lg">Luganda</option>
                                        <option value="lb">
                                          Luxembourgish
                                        </option>
                                        <option value="mk">Macedonian</option>
                                        <option value="mai">Maithili</option>
                                        <option value="mg">Malagasy</option>
                                        <option value="ms">Malay</option>
                                        <option value="ml">Malayalam</option>
                                        <option value="mt">Maltese</option>
                                        <option value="mi">Maori</option>
                                        <option value="mr">Marathi</option>
                                        <option value="mni-Mtei">
                                          Meiteilon (Manipuri)
                                        </option>
                                        <option value="lus">Mizo</option>
                                        <option value="mn">Mongolian</option>
                                        <option value="my">
                                          Myanmar (Burmese)
                                        </option>
                                        <option value="ne">Nepali</option>
                                        <option value="no">Norwegian</option>
                                        <option value="or">Odia (Oriya)</option>
                                        <option value="om">Oromo</option>
                                        <option value="ps">Pashto</option>
                                        <option value="fa">Persian</option>
                                        <option value="pl">Polish</option>
                                        <option value="pt">Portuguese</option>
                                        <option value="pa">Punjabi</option>
                                        <option value="qu">Quechua</option>
                                        <option value="ro">Romanian</option>
                                        <option value="ru">Russian</option>
                                        <option value="sm">Samoan</option>
                                        <option value="sa">Sanskrit</option>
                                        <option value="gd">Scots Gaelic</option>
                                        <option value="nso">Sepedi</option>
                                        <option value="sr">Serbian</option>
                                        <option value="st">Sesotho</option>
                                        <option value="sn">Shona</option>
                                        <option value="sd">Sindhi</option>
                                        <option value="si">Sinhala</option>
                                        <option value="sk">Slovak</option>
                                        <option value="sl">Slovenian</option>
                                        <option value="so">Somali</option>
                                        <option value="es">Spanish</option>
                                        <option value="su">Sundanese</option>
                                        <option value="sw">Swahili</option>
                                        <option value="sv">Swedish</option>
                                        <option value="tg">Tajik</option>
                                        <option value="ta">Tamil</option>
                                        <option value="tt">Tatar</option>
                                        <option value="te">Telugu</option>
                                        <option value="th">Thai</option>
                                        <option value="ti">Tigrinya</option>
                                        <option value="ts">Tsonga</option>
                                        <option value="tr">Turkish</option>
                                        <option value="tk">Turkmen</option>
                                        <option value="ak">Twi</option>
                                        <option value="uk">Ukrainian</option>
                                        <option value="ur">Urdu</option>
                                        <option value="ug">Uyghur</option>
                                        <option value="uz">Uzbek</option>
                                        <option value="vi">Vietnamese</option>
                                        <option value="cy">Welsh</option>
                                        <option value="xh">Xhosa</option>
                                        <option value="yi">Yiddish</option>
                                        <option value="yo">Yoruba</option>
                                        <option value="zu">Zulu</option>
                                      </select>
                                    </div>
                                    Powered by{" "}
                                    <span style={{ whiteSpace: "nowrap" }}>
                                      <a
                                        className="VIpgJd-ZVi9od-l4eHX-hSRGPd"
                                        href="https://translate.google.com"
                                        target="_blank"
                                      >
                                        <img
                                          src="https://www.gstatic.com/images/branding/googlelogo/1x/googlelogo_color_42x16dp.png"
                                          width="37px"
                                          height="14px"
                                          style={{ paddingRight: "3px" }}
                                          alt="Google Translate"
                                        />
                                        Translate
                                      </a>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              {/* google translate end */}
                            </li>
                          </ul>
                        </div>
                        <div className="footer__nav-col hidden-sm">
                          <h4 className="footer-title">Language </h4>
                          <ul className="footer__nav">
                            <li className="is-active">
                              <a href="#">ENGLISH </a>
                            </li>
                            <li className>
                              <a href="#">SPANISH </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="footer__bottom">
                    <p>
                      © Copyright, <span className="js-current-year">2023</span>{" "}
                      Cetofinance.com. All Rights Reserved
                    </p>
                    <ul>
                      <li>
                        <a href="?a=rules">Privacy Policy</a>
                      </li>
                      <li>License 13699699</li>
                    </ul>
                  </div>
                </div>
              </footer>
            </div>
            {/* Right bar*/}
            <div className="bar">
              {" "}
              <a className="logout-btn" onClick={logout}>
                <svg className="svg-icon">
                  <use href="assets/icons/sprite.svg#icon-logout" />
                </svg>
                <p className="logout-btn__name">Logout</p>
              </a>
            </div>
            {/* Mobile menu*/}
            <div className="mobile-menu">
              <div className="mobile-menu__top">
                {/* If auth*/}
                <a className="link-icon" href="profile-account.html">
                  <svg className="svg-icon">
                    <use href="assets/icons/sprite.svg#icon-003-shield" />
                  </svg>
                  <span>{userdetails.fullname}</span>
                </a>
                <div className="total-balance">
                  Total Balance <span>0 USD</span>
                </div>
              </div>
              {/* If Auth*/}
              <nav className="mobile-menu__nav">
                <ul>
                  <li className="is-active">
                    <a href="/dashboards">
                      <span className="mobile-menu__icon">
                        <svg className="svg-icon">
                          <use href="/dashboard/assets/icons/sprite.svg#icon-001-user-profile" />
                        </svg>
                      </span>
                      <span>Account </span>
                    </a>
                  </li>
                  <li>
                    <a href="/deposit">
                      <span className="mobile-menu__icon">
                        <svg className="svg-icon">
                          <use href="/dashboard/assets/icons/sprite.svg#icon-002-deposit" />
                        </svg>
                      </span>
                      <span>Invest </span>
                    </a>
                  </li>
                  <li>
                    <a href="deposit">
                      <span className="mobile-menu__icon">
                        <svg className="svg-icon">
                          <use href="/dashboard/assets/icons/sprite.svg#icon-002-deposit" />
                        </svg>
                      </span>
                      <span>Reinvest </span>
                    </a>
                  </li>
                  <li>
                    <a href="withdrawal">
                      <span className="mobile-menu__icon">
                        <svg className="svg-icon">
                          <use href="/dashboard/assets/icons/sprite.svg#icon-002-wallet" />
                        </svg>
                      </span>
                      <span>Withdraw funds </span>
                    </a>
                  </li>
                  <li>
                    <a href="/depositlist">
                      <span className="mobile-menu__icon">
                        <svg className="svg-icon">
                          <use href="/dashboard/assets/icons/sprite.svg#icon-double" />
                        </svg>
                      </span>
                      <span>My Deposits </span>
                    </a>
                  </li>
                  <li>
                    <a href="?a=earnings">
                      <span className="mobile-menu__icon">
                        <svg className="svg-icon">
                          <use href="/dashboard/assets/icons/sprite.svg#icon-double" />
                        </svg>
                      </span>
                      <span>Operations </span>
                    </a>
                  </li>
                  <li>
                    <a href="/refferals">
                      <span className="mobile-menu__icon">
                        <svg className="svg-icon">
                          <use href="/dashboard/assets/icons/sprite.svg#icon-scheme" />
                        </svg>
                      </span>
                      <span>Referrals </span>
                    </a>
                  </li>
                  <li>
                    <a href="/settings">
                      <span className="mobile-menu__icon">
                        <svg className="svg-icon">
                          <use href="/dashboard/assets/icons/sprite.svg#icon-001-settings" />
                        </svg>
                      </span>
                      <span>Settings </span>
                    </a>
                  </li>
                  <li>
                    <a onClick={logout}>
                      <span className="mobile-menu__icon">
                        <svg className="svg-icon">
                          <use href="/dashboard/assets/icons/sprite.svg#icon-logout" />
                        </svg>
                      </span>
                      <span>Logout </span>
                    </a>
                  </li>
                </ul>
              </nav>
              <nav className="mobile-menu__nav">
                <ul>
                  <li>
                    <a href="?a=">Home page </a>
                  </li>
                  <li>
                    <a href="?a=about">About us</a>
                  </li>
                  <li>
                    <a href="?a=investments">Investments</a>
                  </li>
                  <li>
                    <a href="?a=faq">FAQ</a>
                  </li>
                  <li>
                    <a href="?a=contacts">Contacts</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          {/* Modals*/}
          {/* success*/}
          <div className="modal" id="successdep">
            <div className="modal-inner">
              <div className="modal-inner__close js-close-modal">
                <svg className="svg-icon">
                  <use href="assets/icons/sprite.svg#icon-cross" />
                </svg>
              </div>
              <div className="modal-header">
                <h3 className="title">Success! </h3>
              </div>
              <div id="depposit">
                <div className="modal-content">
                  <div className="typography">
                    <p id="infs" />
                  </div>
                  <div className="modal-icon">
                    {" "}
                    <img src="assets/images/check-line.svg" alt="" />
                  </div>
                </div>
                <div className="modal-footer modal-footer--center">
                  <button className="btn btn--primary js-close-modal">
                    Close{" "}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal" id="success">
            <div className="modal-inner">
              <div className="modal-inner__close js-close-modal">
                <svg className="svg-icon">
                  <use href="assets/icons/sprite.svg#icon-cross" />
                </svg>
              </div>
              <div className="modal-header">
                <h3 className="title">Success! </h3>
              </div>
              <div className="modal-content">
                <div className="typography">
                  <p id="infs" />
                </div>
                <div className="modal-icon">
                  {" "}
                  <img src="assets/images/check-line.svg" alt="" />
                </div>
              </div>
              <div className="modal-footer modal-footer--center">
                <button className="btn btn--primary js-close-modal">
                  Close{" "}
                </button>
              </div>
            </div>
          </div>
          {/* error*/}
          <div className="modal" id="error">
            <div className="modal-inner">
              <div className="modal-inner__close js-close-modal">
                <svg className="svg-icon">
                  <use href="assets/icons/sprite.svg#icon-cross" />
                </svg>
              </div>
              <div className="modal-header">
                <h3 className="title">Error! </h3>
              </div>
              <div className="modal-content">
                <div className="typography">
                  <p id="inf" />
                </div>
                <div className="modal-icon">
                  {" "}
                  <img src="assets/images/cross-line.svg" alt="" />
                </div>
              </div>
              <div className="modal-footer modal-footer--center">
                <button className="btn btn--primary js-close-modal">
                  Close{" "}
                </button>
              </div>
            </div>
          </div>
          {/* gradient all svg*/}
          <svg className="primary-gradient">
            <linearGradient id="primary-gradient">
              <stop offset="0%" stopColor="#49ecdd" />
              <stop offset="100%" stopColor="#94d472" />
            </linearGradient>
          </svg>
        </main>
        <div
          id="goog-gt-tt"
          className="VIpgJd-yAWNEb-L7lbkb skiptranslate"
          style={{
            borderRadius: "12px",
            margin: "0 0 0 -23px",
            padding: 0,
            fontFamily: '"Google Sans", Arial, sans-serif',
          }}
          data-id
        >
          <div id="goog-gt-vt" className="VIpgJd-yAWNEb-hvhgNd">
            <div className=" VIpgJd-yAWNEb-hvhgNd-l4eHX-i3jM8c">
              <img
                src="https://fonts.gstatic.com/s/i/productlogos/translate/v14/24px.svg"
                width={24}
                height={24}
                alt=""
              />
            </div>
            <div className=" VIpgJd-yAWNEb-hvhgNd-k77Iif-i3jM8c">
              <div className="VIpgJd-yAWNEb-hvhgNd-IuizWc" dir="ltr">
                Original text
              </div>
              <div
                id="goog-gt-original-text"
                className="VIpgJd-yAWNEb-nVMfcd-fmcmS VIpgJd-yAWNEb-hvhgNd-axAV1"
              />
            </div>
            <div className="VIpgJd-yAWNEb-hvhgNd-N7Eqid ltr">
              <div className="VIpgJd-yAWNEb-hvhgNd-N7Eqid-B7I4Od ltr" dir="ltr">
                <div className="VIpgJd-yAWNEb-hvhgNd-UTujCb">
                  Rate this translation
                </div>
                <div className="VIpgJd-yAWNEb-hvhgNd-eO9mKe">
                  Your feedback will be used to help improve Google Translate
                </div>
              </div>
              <div className="VIpgJd-yAWNEb-hvhgNd-xgov5 ltr">
                <button
                  id="goog-gt-thumbUpButton"
                  type="button"
                  className="VIpgJd-yAWNEb-hvhgNd-bgm6sf"
                  title="Good translation"
                  aria-label="Good translation"
                  aria-pressed="false"
                >
                  <span id="goog-gt-thumbUpIcon">
                    <svg
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      focusable="false"
                      className="VIpgJd-yAWNEb-hvhgNd-THI6Vb NMm5M"
                    >
                      <path d="M21 7h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 0S7.08 6.85 7 7H2v13h16c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73V9c0-1.1-.9-2-2-2zM7 18H4V9h3v9zm14-7l-3 7H9V8l4.34-4.34L12 9h9v2z" />
                    </svg>
                  </span>
                  <span id="goog-gt-thumbUpIconFilled">
                    <svg
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      focusable="false"
                      className="VIpgJd-yAWNEb-hvhgNd-THI6Vb NMm5M"
                    >
                      <path d="M21 7h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 0S7.08 6.85 7 7v13h11c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73V9c0-1.1-.9-2-2-2zM5 7H1v13h4V7z" />
                    </svg>
                  </span>
                </button>
                <button
                  id="goog-gt-thumbDownButton"
                  type="button"
                  className="VIpgJd-yAWNEb-hvhgNd-bgm6sf"
                  title="Poor translation"
                  aria-label="Poor translation"
                  aria-pressed="false"
                >
                  <span id="goog-gt-thumbDownIcon">
                    <svg
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      focusable="false"
                      className="VIpgJd-yAWNEb-hvhgNd-THI6Vb NMm5M"
                    >
                      <path d="M3 17h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 24s7.09-6.85 7.17-7h5V4H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2zM17 6h3v9h-3V6zM3 13l3-7h9v10l-4.34 4.34L12 15H3v-2z" />
                    </svg>
                  </span>
                  <span id="goog-gt-thumbDownIconFilled">
                    <svg
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      focusable="false"
                      className="VIpgJd-yAWNEb-hvhgNd-THI6Vb NMm5M"
                    >
                      <path d="M3 17h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 24s7.09-6.85 7.17-7V4H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2zm16 0h4V4h-4v13z" />
                    </svg>
                  </span>
                </button>
              </div>
            </div>
            <div
              id="goog-gt-votingHiddenPane"
              className="VIpgJd-yAWNEb-hvhgNd-aXYTce"
            >
              <form
                id="goog-gt-votingForm"
                action="//translate.googleapis.com/translate_voting?client=te"
                method="post"
                target="votingFrame"
                className="VIpgJd-yAWNEb-hvhgNd-aXYTce"
              >
                <input type="text" name="sl" id="goog-gt-votingInputSrcLang" />
                <input type="text" name="tl" id="goog-gt-votingInputTrgLang" />
                <input
                  type="text"
                  name="query"
                  id="goog-gt-votingInputSrcText"
                />
                <input
                  type="text"
                  name="gtrans"
                  id="goog-gt-votingInputTrgText"
                />
                <input type="text" name="vote" id="goog-gt-votingInputVote" />
              </form>
              <iframe name="votingFrame" frameBorder={0} />
            </div>
          </div>
        </div>
        <div className="VIpgJd-ZVi9od-aZ2wEe-wOHMyf">
          <div className="VIpgJd-ZVi9od-aZ2wEe-OiiCO">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="VIpgJd-ZVi9od-aZ2wEe"
              width="96px"
              height="96px"
              viewBox="0 0 66 66"
            >
              <circle
                className="VIpgJd-ZVi9od-aZ2wEe-Jt5cK"
                fill="none"
                strokeWidth={6}
                strokeLinecap="round"
                cx={33}
                cy={33}
                r={30}
              />
            </svg>
          </div>
        </div>
        <iframe
          id="chat-application-iframe"
          title="Smartsupp"
          aria-hidden="true"
          style={{
            display: "block",
            position: "fixed",
            top: "0px",
            left: "0px",
            width: "1px",
            height: "1px",
            opacity: 0,
            border: "none",
            zIndex: -1,
            pointerEvents: "none",
          }}
        />
        <div id="smartsupp-widget-container">
          {" "}
          <div
            data-testid="widgetButtonFrame"
            style={{
              borderRadius: "9999px",
              boxShadow:
                "rgba(0, 0, 0, 0.06) 0px 1px 6px 0px, rgba(0, 0, 0, 0.12) 0px 2px 32px 0px",
              height: "56px",
              position: "fixed",
              bottom: "24px",
              left: "initial",
              right: "12px",
              zIndex: 10000000,
              width: "109px",
            }}
          >
            <iframe
              id="widgetButtonFrame"
              title="Smartsupp widget button"
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                border: "none",
                display: "block",
                textAlign: "left",
                margin: "0px",
                padding: "0px",
                top: "0px",
                left: "0px",
                opacity: 1,
              }}
              allowFullScreen
              scrolling="no"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Deposit;
